import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Notfound from "../Components/Common/Notfound";
import QuoteImage from "../Components/Common/QuoteImage";
import MainLayout from "../Container/Layout/MainLayout";
import { Context } from "../Context/Context";
import {
  getAllMaterials,
  getEditOrder,
  getMaterialPersianGroups,
  getSingleMaterial,
  getproperties,
  priceService,
  putTwoDimensionalMap,
  repriceService,
  searchMaterials,
  updateService,
  getAvailableMaterials,
} from "../Services/ContectService";
import styles from "../Styles/EditOrder.module.css";
import { boolean } from "yup";

const materialFields = [
  "manufacturer_reference",
  "aisi_sae",
  "din",
  "uns",
  "wnr",
  "afnor",
  "bts",
  "jis",
  "en",
  "uni",
  "sis",
  "astm",
];
const selectPointArray = [
  {
    text: "انتخاب کل فیچر",
    value: "AllFeature",
  },
  {
    text: "انتخاب سطوح مشابه",
    value: "Similar",
  },
  {
    text: "انتخاب همه سطوح",
    value: "All",
  },
  {
    text: "شفافیت",
    value: "Transparency",
  },
  {
    text: "جزيیات",
    value: "Deatail",
  },
  {
    text: "انتخاب برعکس",
    value: "Reverse"
  }
];
const viewPointsArray = [
  {
    text: "بالا",
    value: "top",
  },
  {
    text: "پایین",
    value: "bottom",
  },
  {
    text: "روبه‌رو",
    value: "front",
  },
  {
    text: "پشت",
    value: "back",
  },
  {
    text: "چپ",
    value: "left",
  },
  {
    text: "راست",
    value: "right",
  },
];

const EditOrder = () => {
  const { json, user, loading, setLoading, numberconvert } =
    useContext(Context);
  const content = json?.OrderInformation;

  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const hoveredShapeModalRef = useRef(null);
  const iFrameContainerRef = useRef(null);

  // tab && modal && pages
  const [uploadModal, setUploadModal] = useState(true);
  const [priceModal, setPriceModal] = useState(false);
  const [tab, setTab] = useState(0);
  const [tabInformationRight, setTabInformationRight] = useState(true);
  const [pageMaterials, setPageMaterials] = useState(1);
  const [addAtrShape, setAddAtrShape] = useState([]); // faces (for show user)

  // tab defult data with feth
  const [data, setData] = useState(null);
  const [backupData, setBackupData] = useState(null);
  const [materials, setMaterials] = useState(null);
  const [searchMaterial, setSearchMaterial] = useState("");
  const [availableMaterial, setAvailableMaterial] = useState(true);
  const [materialCategory, setMaterialCategory] = useState("");
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const [priceModalItem, setPriceModalItem] = useState(null);
  const [backupPriceModalItem, setBackupPriceModalItem] = useState(null);
  const [searchInput, setSearchInput] = useState(false);
  const [offlineFileFormat, setOfflineFileFormat] = useState(0);
  const [X3DEventAdded, setX3DEventAdded] = useState(false);
  const [hoveredShapeData, setHoveredShapeData] = useState([]);
  const [showHoveredShape, setShowHoveredShape] = useState(false);
  const [searchMaterialLoading, setSearchMaterialLoading] = useState(false);
  const [repricingLoading, setRepricingLoading] = useState(false);
  const [hasErrors, setHasErrors] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const [selectedPlanData, setSelectedPlanData] = useState(null);
  const [stopSendingRequest, setStopSendingRequest] = useState(false);
  const [localFileUploaded, setLocalFileUploaded] = useState(false);
  const [localFileLoading, setLocalFileLoading] = useState(false);
  const [isSelectedSimilarShapes, setIsSelectedSimilarShapes] = useState(false);
  const [isSelectedAllFeatures, setIsSelectedAllFeatures] = useState(false);
  const [isSelectedReverseFeatures, setIsSelectedReverseFeatures] = useState(false);
  const [isSelectedAllShapes, setIsSelectedAllShapes] = useState(false);

  // properties
  const [properties, setProperties] = useState([]);
  const [propertiesTechnology, setPropertiesTechnology] = useState([]);
  const [propertiesAdditional, setPropertiesAdditional] = useState([]);
  const [propertiesRoughness, setPropertiesRoughness] = useState([]);
  const [propertiesDimTolerance, setPropertiesDimTolerance] = useState([]);
  const [propertiesGeoTolerance, setPropertiesGeoTolerance] = useState([]);
  const [propertiesPlan, setPropertiesPlan] = useState([]);

  // state select data
  const [technologySelect, setTechnologySelect] = useState(""); // technology
  const [additionalSelect, setAdditionalSelect] = useState(""); // additional_operations
  const [roughnessSelect, setRoughnessSelect] = useState(""); // general_roughness
  const [planSelect, setPlanSelect] = useState(""); // plan
  const [materialSelect, setMaterialSelect] = useState(null); // material
  const [customMaterialSelect, setCustomMaterialSelect] = useState(false);
  const [customMaterialSelectName, setCustomMaterialSelectName] = useState(""); // custom_material
  const [customerDescription, setCustomerDescription] = useState(""); // customer_description
  const [number, setNumber] = useState(1); // quantity
  const [unitPrice, setUnitPrice] = useState(0); // unit_price
  const [totalPrice, setTotalPrice] = useState(0); // total_price
  const [datePreparation, setDatePreparation] = useState(""); // preparation_date
  const [unit, setUnit] = useState("mm"); // unit
  const [dimensions, setDimensions] = useState(""); // properties.blank_dimensions
  const [twoDimensionalMap, setTwoDimensionalMap] = useState(null); // drawing (file)
  const [drawing, setDrawing] = useState(""); // drawing
  const [geoToleranceSelect, setGeoToleranceSelect] = useState(""); // general_geo_tolerance
  const [dimToleranceSelect, setDimToleranceSelect] = useState(""); // general_dim_tolerance
  const [supply, setSupply] = useState(""); // supply (تامین ماده اولیه توسط مشتری)
  const [pureSupply, setPureSupply] = useState("");
  const [facesData, setFacesData] = useState([]); // faces
  const [hasWorkingFaces, setHasWorkingFaces] = useState(""); // has_working_faces
  const [workingFaces, setWorkingFaces] = useState([]); // working_faces

  // local setting select (faces fields)
  const [fitOptions, setFitOptions] = useState([]); // fit (انطباق) options
  const [threadOptions, setThreadOptions] = useState([]); // thread (رزوه) options
  const [isDisabled, setIsDisabled] = useState(false); // disable fit and thread selectbox while one of the selected pages doesn't have type=2
  const [isAllFieldsDisabled, setIsAllFieldsDisabled] = useState(false); // disable all local fields when on of pages doesn't exist in workingFaces

  // timeouts
  const [getDataTimeout, setGetDataTimeout] = useState(undefined);
  const [repriceTimeout, setRepriceTimeout] = useState(undefined);
  const [priceTimeout, setPriceTimeout] = useState(undefined);
  const [searchMaterialTimeout, setSearchMaterialTimeout] = useState(undefined);

  // Icons of x3d file
  const [transparency, setTransparency] = useState("0");

  // handler
  const getOrderDataHandeler = async () => {
    setLoading(true);
    try {
      const response = await getEditOrder(user, params.id);
      if (response.status === 200) {
        setData(response.data);
        setBackupData(response.data);
        setFacesData(response.data.process_output.faces);
        setHasWorkingFaces(response.data.process_output.has_working_faces);
        setWorkingFaces(response.data.process_output.working_faces);
        setHasErrors(
          response.data.alert.errors.length > 0 ||
          location.pathname.toLowerCase().includes("detailorder")
        );
        setLoading(false);
      } else if (response.status === 204) {
        callGetOrderDataHandeler();
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
      return navigate("/");
    }
  };

  const callGetOrderDataHandeler = () => {
    clearTimeout(getDataTimeout);
    let to = setTimeout(() => {
      getOrderDataHandeler();
    }, 10000);
    setGetDataTimeout(to);
  };

  const getpropertiesHandeler = async () => {
    setLoading(true);
    try {
      const response = await getproperties(user);
      if (response.status === 200) {
        setProperties(response.data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const handleGetMaterialPersianGroups = async () => {
    setLoading(true);
    try {
      const response = await getMaterialPersianGroups(user);
      if (response.status === 200) {
        setMaterialCategoryOptions(
          response.data.map((item) => item.persian_group)
        );
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const clickForGreenPage = () => {
    setTimeout(() => {
      const x3dCanvas = document
        .getElementsByTagName("iframe")[0]
        .contentWindow.document.getElementById("x3dom-x3d-canvas");
      x3dCanvas.click()
    }, 500)
  }

  const getMaterialsHandler = async () => {
    try {
      const response = await getAllMaterials(
        user,
        pageMaterials,
        searchMaterial,
        materialCategory,
        availableMaterial
      );
      if (response.status === 200) {
        setPageMaterials(pageMaterials + 1);
        if (materials) {
          let newmaterials = {
            materials: [...materials.materials, ...response.data.results],
            pages: response.data.pages,
          };
          setMaterials(newmaterials);
        } else {
          setMaterials({
            materials: response.data.results,
            pages: response.data.pages,
          });
        }
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const searchMaterialsHandler = async (
    search,
    category,
    availableMaterial
  ) => {
    try {
      const response = await searchMaterials(
        user,
        search,
        category,
        availableMaterial
      );
      if (response.status === 200) {
        setMaterials({
          materials: response.data.results,
          pages: response.data.pages,
        });
        setPageMaterials(2);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setSearchMaterialLoading(false);
    }
  };

  const getSingleMaterialhandler = async (id) => {
    try {
      const response = await getSingleMaterial(user, id);
      if (response.status === 200) {
        setMaterialSelect(response.data);
        setSupply((prevValue) => {
          return !Boolean(response.data.cost) ? 0 : prevValue;
        });
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const handleScroll = (e) => {
    // const condition = Math.round(e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight;
    const condition =
      Math.ceil(e.target.scrollHeight - e.target.clientHeight) <=
      Math.ceil(e.target.scrollTop) + 5;
    if (condition && pageMaterials <= materials.pages) {
      getMaterialsHandler();
    }
  };

  const servicePriceHandeler = async () => {
    setLoading(true);
    try {
      const response = await priceService(user, params.id);
      if (response.status === 200) {
        setPriceModalItem(response.data);
        setBackupPriceModalItem(response.data);
      } else if (response.status === 204) {
        const result = await repriceService(user, params.id, "read");
        if (result.status === 200) {
          setPriceModalItem(result.data);
          setBackupPriceModalItem(result.data);
        } else if (result.status === 204) {
          pricingHandler();
        }
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    }
  };

  const repricingHandler = async (fData) => {
    setRepricingLoading(true);
    toast.info("لطفاً تا محاسبه‌ی قیمت جدید صبر کنید");
    console.log(planSelect)

    let values1;
    let values2;


    if (fData) {
      values1 = {
        ...data.process_output,
        technology: Number(technologySelect),
        additional_operations: Number(additionalSelect),
        general_roughness: Number(roughnessSelect),
        plan: fData.plan_id,
        material: materialSelect
          ? Number(materialSelect.id)
          : Number(data.process_output.material),
        custom_material: customMaterialSelectName || "",
        // quantity: Number.isNaN(Number(fData.quantity)) ? 1 : Number(number),
        // unit_price: Number.isNaN(Number(fData.unit_price)) ? "" : Number(unitPrice),
        quantity: fData.quantity,
        unit_price: fData.unit_price,
        unit: unit,
        drawing: drawing,
        general_geo_tolerance: Number(geoToleranceSelect),
        general_dim_tolerance: Number(dimToleranceSelect),
        supply: Number(supply),
        faces: facesData,
        has_working_faces: Number(hasWorkingFaces),
        working_faces: workingFaces,
      };

      values2 = {
        custom_material: customMaterialSelectName || "",
        customer_description: customerDescription,
        real_time: priceModalItem?.real_time,
        time: fData.preparation_time,
        offline: priceModalItem?.offline,
        mass: priceModalItem?.mass,
      };
    } else {
      values1 = {
        ...data.process_output,
        technology: Number(technologySelect),
        additional_operations: Number(additionalSelect),
        general_roughness: Number(roughnessSelect),
        plan: Number(planSelect),
        material: materialSelect
          ? Number(materialSelect.id)
          : Number(data.process_output.material),
        custom_material: customMaterialSelectName || "",
        quantity: Number.isNaN(Number(number)) ? 1 : Number(number),
        unit_price: Number.isNaN(Number(unitPrice)) ? "" : Number(unitPrice),
        unit: unit,
        drawing: drawing,
        general_geo_tolerance: Number(geoToleranceSelect),
        general_dim_tolerance: Number(dimToleranceSelect),
        supply: Number(supply),
        faces: facesData,
        has_working_faces: Number(hasWorkingFaces),
        working_faces: workingFaces,
      };

      values2 = {
        custom_material: customMaterialSelectName || "",
        customer_description: customerDescription,
        real_time: priceModalItem?.real_time,
        time: priceModalItem?.time,
        offline: priceModalItem?.offline,
        mass: priceModalItem?.mass,
      };
    }


    const finalValues = {
      json_process_data: values1,
      general_data: values2,
    };

    try {
      const response = await updateService(user, finalValues, params.id, false);
      if (response.status === 201) {
        const result = await repriceService(user, params.id);
        if (result.status === 200) {
          setPriceModalItem(result.data);
          setRepricingLoading(false);
        } else if (result.status === 204) {
          pricingHandler();
        }
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      // if (!priceTimeout) {
      //     setRepricingLoading(false);
      // }
      setRepricingLoading(false);
    }
  };

  const callRepricingHandler = () => {
    clearTimeout(repriceTimeout);
    let to = setTimeout(() => {
      repricingHandler(null);
    }, 1000);
    setRepriceTimeout(to);
  };

  const pricingHandler = async () => {
    setRepricingLoading(true);
    try {
      const response = await priceService(user, params.id);
      if (response.status === 200) {
        setPriceModalItem(response.data);
        setRepricingLoading(false);
      } else if (response.status === 204) {
        callPricingHandler();
      }
    } catch (error) {
      toast.error(json.toast.err_1);
      setRepricingLoading(false);
    }
  };

  const callPricingHandler = () => {
    clearTimeout(priceTimeout);
    let to = setTimeout(() => {
      pricingHandler();
    }, 5000);
    setPriceTimeout(to);
  };

  const handleSetSearchMaterial = (value) => {
    setSearchMaterialLoading(value.length > 0 ? true : false);
    if (value.length === 0) {
      setSearchMaterial(value);
    }
    clearTimeout(searchMaterialTimeout);
    let to = setTimeout(() => {
      setSearchMaterial(value);
    }, 1000);
    setSearchMaterialTimeout(to);
  };

  const findUnitPriceHandler = () => {
    setUnitPrice(priceModalItem?.unit_price);
    setTotalPrice(priceModalItem?.total_price);
    setDatePreparation(priceModalItem?.time);
  };

  const setDataHandler = () => {
    console.log("this is the geo toleranse: ", data.process_output.general_geo_tolerance)
    setNumber(data.process_output.quantity || 1);
    setSupply(data.process_output.supply);
    setPureSupply(data.process_output.supply);
    setOfflineFileFormat(data.process_output.offline_file_format);
    setUploadModal(
      data.process_output.offline_file_format == 0 &&
        data.process_output.drawing == 0
        ? true
        : false
    );
    setCustomerDescription(data.service_detail.customer_description || "");
    setCustomMaterialSelectName(data.service_detail.custom_material);
    setCustomMaterialSelect(data.service_detail.custom_material ? true : false);
    setDrawing(data.process_output.drawing);
    if (data.process_output.technology !== null) {
      setTechnologySelect(
        propertiesTechnology.find(
          (item) => item.value == data.process_output.technology
        )?.value
      );
    }
    if (data.process_output.additional_operations !== null) {
      setAdditionalSelect(
        propertiesAdditional.find(
          (item) => item.value == data.process_output.additional_operations
        )?.value
      );
    }
    if (data.process_output.general_roughness !== null) {
      setRoughnessSelect(
        propertiesRoughness.find(
          (item) => item.value == data.process_output.general_roughness
        )?.value
      );
    }
    if (data.process_output.material !== null) {
      // searchMaterialsHandler(data.process_output.material, "", true);
      // searchMaterialsHandler("", "", data.process_output.material, true);
      getSingleMaterialhandler(data.process_output.material);
    }
    if (data.process_output.general_geo_tolerance !== null) {
      setGeoToleranceSelect(
        propertiesGeoTolerance.find(
          (item) => item.value == data.process_output.general_geo_tolerance
        )?.value
      );
    }
    if (data.process_output.general_dim_tolerance !== null) {
      setDimToleranceSelect(
        propertiesDimTolerance.find(
          (item) => item.value == data.process_output.general_dim_tolerance
        )?.value
      );
    }
    if (data.process_output.properties.blank_dimensions) {
      setDimensions(data.process_output.properties.blank_dimensions);
    }
    if (data.process_output.unit !== null) {
      setUnit(data.process_output.unit);
    }
    if (data.process_output.plan !== null) {
      setPlanSelect(
        propertiesPlan.find((item) => item.value == data.process_output.plan)
          ?.value
      );
      findUnitPriceHandler();
    } else {
      setPlanSelect(0);
      findUnitPriceHandler();
    }
  };

  const editJsonShowAndFacesHandler = (
    name,
    value,
    pages = [],
    callReprice = true
  ) => {
    const names = [
      {
        name: "fit",
        show: "انطباق",
      },
      {
        name: "thread",
        show: "رزوه",
      },
      {
        name: "roughness",
        show: "زبری سطح",
      },
      {
        name: "dim_tolerance",
        show: "دقت ابعادی",
      },
      {
        name: "geo_tolerance",
        show: "دقت هندسی",
      },
    ];
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let itemSelectedShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("itemSelectedShape");
    if (itemSelectedShape.innerText.length > 0 || pages.length > 0) {
      // Show changes
      let showName = names.find((n) => n.name === name)?.show;
      let showValue;
      switch (name) {
        case "fit":
          showValue = fitOptions.find((item) => item.value == value)?.slug;
          break;
        case "thread":
          showValue = threadOptions.find((item) => item.value == value)?.slug;
          break;
        case "roughness":
          showValue = propertiesRoughness.find(
            (item) => item.value == value
          )?.slug;
          break;
        case "dim_tolerance":
          showValue = propertiesDimTolerance.find(
            (item) => item.value == value
          )?.slug;
          break;
        case "geo_tolerance":
          showValue = propertiesGeoTolerance.find(
            (item) => item.value == value
          )?.slug;
          break;
        default:
          showValue = value;
          break;
      }

      setFitOptions([]);
      setThreadOptions([]);

      let page =
        pages.length > 0 ? pages : itemSelectedShape.innerText.split(",");
      let allAddAtrShape = addAtrShape;
      let showPage = [];
      for (let shape of page) {
        let sameValueAtr = allAddAtrShape.find(
          (atr) =>
            atr.name === showName &&
            atr.value === showValue &&
            !atr.page.includes(shape)
        );
        let sameValueAtrIndex = allAddAtrShape.findIndex(
          (atr) =>
            atr.name === showName &&
            atr.value === showValue &&
            !atr.page.includes(shape)
        );
        if (sameValueAtr) {
          sameValueAtr.page.push(shape);
          allAddAtrShape[sameValueAtrIndex] = sameValueAtr;
          let extraAtr = allAddAtrShape.find(
            (atr) =>
              atr.name === showName &&
              atr.page.includes(shape) &&
              atr !== sameValueAtr
          );
          let extraAtrIndex = allAddAtrShape.findIndex(
            (atr) =>
              atr.name === showName &&
              atr.page.includes(shape) &&
              atr !== sameValueAtr
          );
          if (extraAtr) {
            extraAtr.page = extraAtr.page.filter((p) => p !== shape);
            allAddAtrShape[extraAtrIndex] = extraAtr;
          }
        } else {
          let currentAtr = allAddAtrShape.find(
            (atr) => atr.name === showName && atr.page.includes(shape)
          );
          let currentAtrIndex = allAddAtrShape.findIndex(
            (atr) => atr.name === showName && atr.page.includes(shape)
          );
          if (currentAtr) {
            if (currentAtr.value !== showValue) {
              currentAtr.page = currentAtr.page.filter((p) => p !== shape);
              allAddAtrShape[currentAtrIndex] = currentAtr;
              let sameValueAtr = allAddAtrShape.find(
                (atr) =>
                  atr.name === showName &&
                  atr.value === showValue &&
                  !atr.page.includes(shape)
              );
              let sameValueAtrIndex = allAddAtrShape.findIndex(
                (atr) =>
                  atr.name === showName &&
                  atr.value === showValue &&
                  !atr.page.includes(shape)
              );
              if (sameValueAtr) {
                sameValueAtr.page.push(shape);
                allAddAtrShape[sameValueAtrIndex] = sameValueAtr;
              } else {
                showPage.push(shape);
              }
            }
          } else {
            showPage.push(shape);
          }
        }
      }

      let newObject = { name: showName, value: showValue, page: showPage };
      if (
        !(
          (showName === "انطباق" || showName === "رزوه") &&
          showValue === "ندارد"
        )
      ) {
        setAddAtrShape((prevValue) => [newObject, ...allAddAtrShape]);
        // setAddAtrShape(prevValue => [...allAddAtrShape, newObject]);
      }
      document
        .getElementsByTagName("iframe")[0]
        .contentWindow.document.getElementById("deselectAll")
        .click();

      // Change faces
      let faces = facesData;
      for (let shape of page) {
        let face = faces.find((f) => f.name == shape);
        let faceIndex = faces.findIndex((f) => f.name == shape);
        if (name === "fit") {
          const uniqueValue = face.fit_list[showValue];
          face[name] = uniqueValue ? Number(uniqueValue) : Number(value);
          faces[faceIndex] = face;
        } else if (name === "thread") {
          const uniqueValue = face.thread_list[showValue];
          face[name] = uniqueValue ? Number(uniqueValue) : Number(value);
          faces[faceIndex] = face;
        } else {
          face[name] = Number(value);
          faces[faceIndex] = face;
        }
      }
      setFacesData(faces);

      toast.success(`با موفقیت روی صفحه (ها)اعمال شد`);

      if (
        data &&
        initialized &&
        !location.pathname.toLowerCase().includes("detailorder") &&
        callReprice
      ) {
        repricingHandler(null);
      }
    } else {
      toast.error("صفحه ای را انتخاب نکردید");
    }
    setIsSelectedSimilarShapes(false);
    setIsSelectedAllFeatures(false);
  };

  const handleDeleteItemFromFaces = (item) => {
    // unhighlight the highlighted pages
    const unhighlightSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("unhighlightSimilarShape");
    if (unhighlightSimilarShape) {
      const pages = facesData.map((item) => item.name);
      unhighlightSimilarShape.setAttribute("select", pages);
      unhighlightSimilarShape.click();
    }

    // set global value for pages of item
    const names = [
      {
        name: "fit",
        show: "انطباق",
      },
      {
        name: "thread",
        show: "رزوه",
      },
      {
        name: "roughness",
        show: "زبری سطح",
      },
      {
        name: "dim_tolerance",
        show: "دقت ابعادی",
      },
      {
        name: "geo_tolerance",
        show: "دقت هندسی",
      },
    ];

    const name = names.find((n) => n.show === item.name)?.name;
    let value;
    switch (name) {
      case "fit":
        value = 0;
        break;
      case "thread":
        value = 0;
        break;
      case "roughness":
        value = roughnessSelect;
        break;
      case "dim_tolerance":
        value = dimToleranceSelect;
        break;
      case "geo_tolerance":
        value = geoToleranceSelect;
        break;
      default:
        value = 0;
        break;
    }

    let faces = facesData;
    for (let shape of item.page) {
      let face = faces.find((f) => f.name == shape);
      let faceIndex = faces.findIndex((f) => f.name == shape);
      face[name] = Number(value);
      faces[faceIndex] = face;
    }
    setFacesData(faces);

    let allAddAtrShape = addAtrShape;
    allAddAtrShape = allAddAtrShape.filter((i) => i !== item);
    // allAddAtrShape = allAddAtrShape.filter(i => i.page !== item.page);
    setAddAtrShape(allAddAtrShape);

    if (name === "fit" || name === "thread") {
      if (
        data &&
        initialized &&
        !location.pathname.toLowerCase().includes("detailorder")
      ) {
        repricingHandler(null);
      }
      return;
    }
    editJsonShowAndFacesHandler(name, value, item.page);
  };

  const setInitialFacesValues = () => {
    let fitInfo = [];
    let threadInfo = [];
    for (let face of facesData) {
      // fit_list
      let fitListKeys = Object.keys(face.fit_list);
      if (fitInfo.length > 0) {
        const fitInfoSlugs = fitInfo.map((item) => item.slug);
        fitListKeys = fitListKeys.filter((key) => !fitInfoSlugs.includes(key));
      }
      const fitList = fitListKeys.map((item) => ({
        value: face.fit_list[item],
        slug: item,
      }));
      fitInfo = [...fitInfo, ...fitList];
      // thread_list
      let threadListKeys = Object.keys(face.thread_list);
      if (threadInfo.length > 0) {
        const threadInfoSlugs = threadInfo.map((item) => item.slug);
        threadListKeys = threadListKeys.filter(
          (key) => !threadInfoSlugs.includes(key)
        );
      }
      const threadList = threadListKeys.map((item) => ({
        value: face.thread_list[item],
        slug: item,
      }));
      threadInfo = [...threadInfo, ...threadList];
    }
    // Remove "ندارد"
    fitInfo = fitInfo.filter((item) => item.slug !== "ندارد");
    threadInfo = threadInfo.filter((item) => item.slug !== "ندارد");

    const roughnessInfo = propertiesRoughness.map((item) => ({
      value: item.value,
      slug: item.slug,
    }));
    const geoToleranceInfo = propertiesGeoTolerance.map((item) => ({
      value: item.value,
      slug: item.slug,
    }));
    const dimToleranceInfo = propertiesDimTolerance.map((item) => ({
      value: item.value,
      slug: item.slug,
    }));
    let allAddAtrShape = [];

    for (let item of fitInfo) {
      const faces = facesData.filter((f) => {
        if (
          Object.keys(f.fit_list).includes(item.slug) &&
          f["fit"] == f.fit_list[item.slug]
        ) {
          return true;
        }
        return false;
      });
      allAddAtrShape.push({
        name: "انطباق",
        value: item.slug,
        page: faces.map((f) => f.name),
      });
    }

    for (let item of threadInfo) {
      const faces = facesData.filter((f) => {
        if (
          Object.keys(f.thread_list).includes(item.slug) &&
          f["thread"] == f.thread_list[item.slug]
        ) {
          return true;
        }
        return false;
      });
      allAddAtrShape.push({
        name: "رزوه",
        value: item.slug,
        page: faces.map((f) => f.name),
      });
    }

    for (let item of roughnessInfo) {
      const faces = facesData.filter((f) => f["roughness"] == item.value);
      allAddAtrShape.push({
        name: "زبری سطح",
        value: item.slug,
        page: faces.map((f) => f.name),
      });
    }

    for (let item of geoToleranceInfo) {
      const faces = facesData.filter((f) => f["geo_tolerance"] == item.value);
      allAddAtrShape.push({
        name: "دقت هندسی",
        value: item.slug,
        page: faces.map((f) => f.name),
      });
    }

    for (let item of dimToleranceInfo) {
      const faces = facesData.filter((f) => f["dim_tolerance"] == item.value);
      allAddAtrShape.push({
        name: "دقت ابعادی",
        value: item.slug,
        page: faces.map((f) => f.name),
      });
    }

    const hasPageAddAtrShape = allAddAtrShape.filter(
      (atr) => atr.page.length > 0
    );
    if (hasPageAddAtrShape.length >= 2) {
      hasPageAddAtrShape.sort((a, b) => {
        if (a.page.length < b.page.length) {
          return -1;
        } else if (a.page.length > b.page.length) {
          return 1;
        }
        return 0;
      });
    }
    setAddAtrShape(hasPageAddAtrShape);
    // setAddAtrShape(allAddAtrShape);
  };

  const setValueForAllFaces = (name, value) => {
    // Show changes
    let compareValue;
    switch (name) {
      case "roughness":
        compareValue = roughnessSelect;
        break;
      case "dim_tolerance":
        compareValue = dimToleranceSelect;
        break;
      case "geo_tolerance":
        compareValue = geoToleranceSelect;
        break;
      default:
        compareValue = value;
        break;
    }

    // Change faces
    let page = [];
    let faces = facesData;
    for (let face of faces) {
      if (face[name] == compareValue) {
        face[name] = Number(value);
        page.push(face.name);
      }
    }
    setFacesData(faces);

    switch (name) {
      case "roughness":
        setRoughnessSelect(value);
        break;
      case "dim_tolerance":
        setDimToleranceSelect(value);
        break;
      case "geo_tolerance":
        setGeoToleranceSelect(value);
        break;
      default:
        break;
    }
    if (page.length === 0) {
      return;
    }

    if (offlineFileFormat == 0) {
      editJsonShowAndFacesHandler(name, value, page, false);
    }
  };

  const similarHandler = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let itemSelectedShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("itemSelectedShape")
      .innerText.split(",");
    let selectSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("selectSimilarShape");
    if (itemSelectedShape.length > 1 || itemSelectedShape[0].length === 0) {
      toast.error(" فقط یک صفحه را انتخاب کنید");
      setIsSelectedSimilarShapes(false);
    } else {
      setIsSelectedSimilarShapes(true);
      let itemSelect = itemSelectedShape[0];
      for (let i = 0; i < data.process_output["same_faces"].length; i++) {
        let find = data.process_output["same_faces"][i].find(
          (item) => item === itemSelect
        );
        if (find) {
          selectSimilarShape.setAttribute(
            "select",
            data.process_output["same_faces"][i]
          );
        }
      }
      selectSimilarShape.click();
    }
  };

  const allFeaturesHandler = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let itemSelectedShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("itemSelectedShape")
      .innerText.split(",");
    let selectSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("selectSimilarShape");
    if (itemSelectedShape.length > 1 || !itemSelectedShape[0]) {
      setIsSelectedAllFeatures(false);
      toast.error(" فقط یک صفحه را انتخاب کنید");
    } else {
      setIsSelectedAllFeatures(true);
      let itemSelect = itemSelectedShape[0];
      for (let item of data.process_output.features) {
        console.log("this is the item faces: ", item.faces)
        let find = item.faces.find((f) => f == itemSelect);
        if (find) {
          selectSimilarShape.setAttribute("select", item.faces);
        }
      }
      selectSimilarShape.click();
    }
  };

  const reverseFeaturesHandler = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let itemSelectedShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("itemSelectedShape")
      .innerText.split(",");
    let selectSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("selectSimilarShape");

    if (!itemSelectedShape[0]) {
      setIsSelectedReverseFeatures(false);
      toast.error("حداقل یک صفحه را انتخاب کنید");
    } else {
      setIsSelectedReverseFeatures(true);
      let reverseSelectedFace = []
      for (let item of data.process_output.faces) {
        for (let face of itemSelectedShape) {
          let find = item.name !== face
          if (find) {
            reverseSelectedFace.push(item.name);
          }
        }
      }
      let uniqueSelectedFace = [...new Set(reverseSelectedFace)]
      selectSimilarShape.setAttribute("select", uniqueSelectedFace.filter(face => !itemSelectedShape.includes(face)));
      selectSimilarShape.click();
    }
  };

  const selectAllShapesHandler = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }

    let selectSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("selectAllShape");

    setIsSelectedAllFeatures(true);

    for (let item of data.process_output.features) {
      selectSimilarShape.setAttribute("select", item.faces);
    }
    selectSimilarShape.click();
  };


  const existAllPagesInWorkingFaces = (pages) => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let workingFacesPages = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("workingFacesPages");
    let workingFacesPagesItems = workingFacesPages.innerText.split(",");
    for (let shape of pages) {
      let find = workingFacesPagesItems.find((wf) => wf == shape);
      if (!find) {
        return false;
      }
    }
    return true;
  };

  const handleSetFacesOptions = () => {
    if (
      [...document.getElementsByTagName("iframe")].length === 0 ||
      facesData.length === 0
    ) {
      return;
    }
    let itemSelectedShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("itemSelectedShape");
    if (itemSelectedShape.innerText.length === 0) {
      setIsSelectedAllFeatures(false);
      setIsSelectedSimilarShapes(false);
      setIsDisabled(false);
      setIsAllFieldsDisabled(false);
      setFitOptions([]);
      setThreadOptions([]);
      return;
    }
    let page = itemSelectedShape.innerText.split(",");
    let workingFacesPages = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("workingFacesPages");
    if (workingFacesPages.innerText.length > 0) {
      if (existAllPagesInWorkingFaces(page)) {
        setIsAllFieldsDisabled(false);
      } else {
        setIsAllFieldsDisabled(true);
        return;
      }
    } else {
      setIsAllFieldsDisabled(false);
    }
    let faces = facesData;
    let fits = [];
    let threads = [];
    for (let shape of page) {
      let face = faces.find((f) => f.name == shape);
      if (face.type != "2") {
        setIsDisabled(true);
        setIsAllFieldsDisabled(false);
        setFitOptions([]);
        setThreadOptions([]);
        return;
      }
      if (fits.length === 0) {
        let fitListKeys = Object.keys(face.fit_list);
        const fitList = fitListKeys.map((item) => ({
          value: face.fit_list[item],
          slug: item,
        }));
        fits = fitList;
      } else {
        fits = fits.filter((f) => Object.keys(face.fit_list).includes(f.slug));
      }
      if (threads.length === 0) {
        let threadListKeys = Object.keys(face.thread_list);
        const threadList = threadListKeys.map((item) => ({
          value: face.thread_list[item],
          slug: item,
        }));
        threads = threadList;
      } else {
        threads = threads.filter((t) =>
          Object.keys(face.thread_list).includes(t.slug)
        );
      }
    }

    setIsDisabled(false);
    setFitOptions(fits);
    setThreadOptions(threads);
  };


  const HandleSetWorkingFaces = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let workingFacesPages = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("workingFacesPages");
    let itemSelectedShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("itemSelectedShape");
    if (itemSelectedShape.innerText.length > 0) {
      let page = itemSelectedShape.innerText.split(",");
      setWorkingFaces(page);
      workingFacesPages.innerText = page;
      changeWorkingFacesColors(page);
      document
        .getElementsByTagName("iframe")[0]
        .contentWindow.document.getElementById("deselectAll")
        .click();
    } else {
      toast.error("صفحه ای را انتخاب نکردید");
    }
  };

  const handleDeleteWorkingFaces = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let workingFacesPages = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("workingFacesPages");
    changeWorkingFacesColors(workingFaces);
    let deselectSelectedShapes = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("deselectSelectedShapes");
    deselectSelectedShapes.setAttribute("select", workingFaces);
    deselectSelectedShapes.click();
    workingFacesPages.innerText = [];
    document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("deselectAll")
      .click();
    setHasWorkingFaces(0);
    setWorkingFaces([]);
    // setFacesData(backupData.process_output.faces);
    // const newAddAtrShape = [
    //     {
    //         name: "زبری سطح",
    //         value: propertiesRoughness.find(p => p.value == roughnessSelect)?.slug,
    //         page: facesData.map(f => f.name)
    //     },
    //     {
    //         name: "دقت هندسی",
    //         value: propertiesGeoTolerance.find(p => p.value == geoToleranceSelect)?.slug,
    //         page: facesData.map(f => f.name)
    //     },
    //     {
    //         name: "دقت ابعادی",
    //         value: propertiesDimTolerance.find(p => p.value == dimToleranceSelect)?.slug,
    //         page: facesData.map(f => f.name)
    //     },
    // ];
    // setAddAtrShape(newAddAtrShape);
  };

  const handleEditWorkingFaces = () => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let workingFacesPages = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("workingFacesPages");
    let selectSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("selectSimilarShape");
    selectSimilarShape.setAttribute("select", workingFaces);
    selectSimilarShape.click();
    changeWorkingFacesColors(workingFaces);
    workingFacesPages.innerText = [];
    setWorkingFaces([]);
  };

  const changeWorkingFacesColors = (pages) => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    let workingFacesItems = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("workingFacesItems");
    workingFacesItems.setAttribute("select", pages);
    workingFacesItems.click();
  };

  const highlightShapesHandler = (pages) => {
    if (offlineFileFormat == 1 || pages.length === 0) {
      return;
    }
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    const highlightSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("highlightSimilarShape");
    if (!highlightSimilarShape) {
      return;
    }
    highlightSimilarShape.setAttribute("select", pages);
    highlightSimilarShape.click();
  };

  const unhighlightShapesHandler = (pages) => {
    if (offlineFileFormat == 1 || pages.length === 0) {
      return;
    }
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    const unhighlightSimilarShape = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("unhighlightSimilarShape");
    if (!unhighlightSimilarShape) {
      return;
    }
    unhighlightSimilarShape.setAttribute("select", pages);
    unhighlightSimilarShape.click();
  };

  const handleShowHoveredShape = (ev) => {
    const id = ev.target.id;
    if (hoveredShapeModalRef.current && iFrameContainerRef.current) {
      hoveredShapeModalRef.current.style.left = `${ev.layerX + iFrameContainerRef.current.getBoundingClientRect().left
        }px`;
      hoveredShapeModalRef.current.style.top = `${ev.layerY + iFrameContainerRef.current.getBoundingClientRect().top
        }px`;
      hoveredShapeModalRef.current.style.display = "block";
    }
    if (id.length > 0 && facesData.length > 0) {
      const face = facesData.find((f) => f.name === id);

      let fitListKeys = Object.keys(face.fit_list);
      const fitList = fitListKeys.map((item) => ({
        value: face.fit_list[item],
        slug: item,
      }));
      let threadListKeys = Object.keys(face.thread_list);
      const threadList = threadListKeys.map((item) => ({
        value: face.thread_list[item],
        slug: item,
      }));

      setHoveredShapeData([
        {
          name: "انطباق",
          value: fitList.find((item) => item.value == face["fit"])?.slug,
        },
        {
          name: "رزوه",
          value: threadList.find((item) => item.value == face["thread"])?.slug,
        },
        {
          name: "زبری سطح",
          value: propertiesRoughness.find(
            (item) => item.value == face["roughness"]
          )?.slug,
        },
        {
          name: "دقت ابعادی",
          value: propertiesDimTolerance.find(
            (item) => item.value == face["dim_tolerance"]
          )?.slug,
        },
        {
          name: "دقت هندسی",
          value: propertiesGeoTolerance.find(
            (item) => item.value == face["geo_tolerance"]
          )?.slug,
        },
      ]);
    } else {
      setHoveredShapeData([]);
    }
  };

  // const testIconHandler = () => {
  //     if ([...document.getElementsByTagName("iframe")].length === 0) {
  //         return;
  //     }
  //     const x3dElement = document.getElementsByTagName("iframe")[0].contentWindow.document.getElementById("x3d");
  //     const x3dCanvas = document.getElementsByTagName("iframe")[0].contentWindow.document.getElementById("x3dom-x3d-canvas");
  //     const x3dNavigationinfo = document.getElementsByTagName("iframe")[0].contentWindow.document.getElementsByTagName("navigationinfo")[0];
  //     // Start
  //     console.log("START CLICK");
  //     // const customEvent = new KeyboardEvent("keydown", {
  //     //     key: 'i',
  //     //     code: 'KeyI',
  //     //     keyCode: 73,
  //     //     composed: true,
  //     //     bubbles: true,
  //     //     cancelable: true,
  //     //     view: window,
  //     // });
  //     // console.log(customEvent);
  //     // console.log(JSON.stringify(customEvent));
  //     // x3dElement.click();
  //     // x3dElement.focus();
  //     // x3dElement.dispatchEvent(customEvent);
  //     // x3dCanvas.click();
  //     // x3dCanvas.focus();
  //     // x3dCanvas.dispatchEvent(customEvent);
  //     let setEventToCanvas = document.getElementsByTagName("iframe")[0].contentWindow.document.getElementById("setEventToCanvas");
  //     setEventToCanvas.setAttribute("data-event", "key");
  //     setEventToCanvas.setAttribute("data-key", "i");
  //     setEventToCanvas.click();
  //     // x3dNavigationinfo.setAttribute("type", '"walk"');
  //     // x3dNavigationinfo.setAttribute("type", '"examine"');
  //     console.log("END CLICK");
  //     // End
  // }

  let interval;
  const callAddEventToX3D = () => {
    if (interval || X3DEventAdded) {
      return;
    }
    interval = setInterval(() => {
      if ([...document.getElementsByTagName("iframe")].length > 0) {
        if (workingFaces.length > 0) {
          changeWorkingFacesColors(workingFaces);
          let workingFacesPages = document
            .getElementsByTagName("iframe")[0]
            .contentWindow.document.getElementById("workingFacesPages");
          if (!workingFacesPages) {
            return;
          }
          workingFacesPages.innerText = data.process_output.working_faces;
          let deselectSelectedShapes = document
            .getElementsByTagName("iframe")[0]
            .contentWindow.document.getElementById("deselectSelectedShapes");
          if (!deselectSelectedShapes) {
            return;
          }
          deselectSelectedShapes.setAttribute(
            "select",
            data.process_output.working_faces
          );
          deselectSelectedShapes.click();
        }
        const x3dElement = document
          .getElementsByTagName("iframe")[0]
          .contentWindow.document.getElementById("x3d");
        const x3dCanvas = document
          .getElementsByTagName("iframe")[0]
          .contentWindow.document.getElementById("x3dom-x3d-canvas");
        if (x3dElement && x3dCanvas) {
          x3dCanvas.addEventListener("keydown", (event) => {
            // console.log("START RUNNING EVENT KEYDOWN FOR X3D");
            // console.log(event);
            let short_keys = [" ", "d", "w", "f", "h", "m", "u", "Tab"];
            if (short_keys.includes(event.key)) {
              event.preventDefault();
            }
          });
          x3dElement.addEventListener("click", handleSetFacesOptions);
          const shapes = x3dElement.getElementsByClassName("color");
          for (let shape of shapes) {
            shape.parentElement.parentElement.addEventListener(
              "mousemove",
              (ev) => handleShowHoveredShape(ev)
            );
            shape.parentElement.parentElement.addEventListener(
              "mouseout",
              () => {
                setHoveredShapeData([]);
                if (hoveredShapeModalRef.current) {
                  hoveredShapeModalRef.current.style.display = "none";
                }
              }
            );
          }
          x3dElement.addEventListener("mouseout", () => {
            setHoveredShapeData([]);
            if (hoveredShapeModalRef.current) {
              hoveredShapeModalRef.current.style.display = "none";
            }

            const unhighlightSimilarShape = document
              .getElementsByTagName("iframe")[0]
              .contentWindow.document.getElementById("unhighlightSimilarShape");
            if (!unhighlightSimilarShape) {
              return;
            }
            const pages = facesData.map((item) => item.name);
            unhighlightSimilarShape.setAttribute("select", pages);
            unhighlightSimilarShape.click();
          });
          setX3DEventAdded(true);
          clearInterval(interval);
        }
      }
    }, 1000);
  };

  // Reprice table
  const setTabHandler = (value) => {
    setTab(value);
    setSelectedPlanData(null);
    setSelectedRowIndex(-1);
  };

  const setSelectedPriceHandler = async (index) => {
    setSelectedRowIndex(index);
    const planTableData = priceModalItem.plan_table[tab];
    let planData = {
      quantity: planTableData.quantity[index],
      unit_price: planTableData.unit_price[index],
      total_price: planTableData.total_price[index],
      preparation_time: planTableData.time[index],
      plan_id: tab,
    };
    setSelectedPlanData(planData);
  };

  const setSelectedDefaultPriceHandler = async () => {
    setSelectedRowIndex(-1);
    let planData = {
      quantity: number,
      unit_price: unitPrice,
      total_price: totalPrice,
      preparation_time: datePreparation,
      plan_id: planSelect,
    };
    setSelectedPlanData(planData);
  };

  const setRepriceData = () => {
    if (selectedRowIndex === -1) {
      toast.info("لطفا یک پلن را انتخاب کنید")
      return
    }

    let planData = {
      quantity: number,
      unit_price: unitPrice,
      total_price: totalPrice,
      preparation_time: datePreparation,
      plan_id: planSelect,
    };

    const finalData = selectedPlanData
    // const finalData = selectedPlanData || planData;
    setNumber(finalData.quantity);
    setUnitPrice(finalData.unit_price);
    setTotalPrice(finalData.total_price);
    setDatePreparation(finalData.preparation_time);
    setPlanSelect(`${finalData.plan_id}`);
    toast.success("تغییرات با موفقیت اعمال شد.");
    setPriceModal(false);

    if (
      data &&
      initialized &&
      !location.pathname.toLowerCase().includes("detailorder")
    ) {
      repricingHandler(finalData);
    }
    setTimeout(() => {
      setStopSendingRequest(false);
    }, 50);
  };

  // X3d file icons functions
  const setViewpointHandler = (item) => {
    if ([...document.getElementsByTagName("iframe")].length === 0) {
      return;
    }
    const x3dElement = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementById("x3d");
    switch (item) {
      case "top":
        x3dElement.runtime.showAll("negY");
        break;
      case "bottom":
        x3dElement.runtime.showAll("posY");
        break;
      case "front":
        x3dElement.runtime.showAll("posX");
        break;
      case "back":
        x3dElement.runtime.showAll("negX");
        break;
      case "left":
        x3dElement.runtime.showAll("negZ");
        break;
      case "right":
        x3dElement.runtime.showAll("posZ");
        break;
      default:
        break;
    }
  };

  // const submitRepricing = async () => {
  //     try {
  //         const result = await repriceService(user, params.id);
  //         if (result.status === 200) {
  //             toast.success("با موفقیت ارسال شد");
  //             setLoading(false);
  //             return navigate("/Quotes");
  //         }
  //         else if (result.status === 204) {
  //             setTimeout(() => {
  //                 submitRepricing();
  //             }, 3000);
  //         }
  //     } catch (error) {
  //         toast.error(json.toast.err_1);
  //         setLoading(false);
  //     }
  // }

  // Submit Handler
  const handleSendData = async () => {
    if (hasWorkingFaces == 1) {
      if (workingFaces.length === 0) {
        return toast.error("حداقل یک صفحه را برای ماشینکاری انتخاب کنید.");
      }
    }
    if (drawing == 1) {
      if (!localFileUploaded) {
        return toast.error(
          "لطفاً فایل نقشه را آپلود کنید یا پارامترهای محلی را از روی مدل سه‌بعدی تعیین کنید"
        );
      }
    }

    setLoading(true);
    const values1 = {
      ...data.process_output,
      technology: Number(technologySelect),
      additional_operations: Number(additionalSelect),
      general_roughness: Number(roughnessSelect),
      plan: Number(planSelect),
      material: materialSelect
        ? Number(materialSelect.id)
        : Number(data.process_output.material),
      custom_material: customMaterialSelectName || "",
      quantity: Number.isNaN(Number(number)) ? 1 : Number(number),
      unit_price: Number.isNaN(Number(unitPrice)) ? "" : Number(unitPrice),
      unit: unit,
      drawing: drawing,
      general_geo_tolerance: Number(geoToleranceSelect),
      general_dim_tolerance: Number(dimToleranceSelect),
      supply: Number(supply),
      faces: facesData,
      has_working_faces: Number(hasWorkingFaces),
      working_faces: workingFaces,
    };

    const values2 = {
      custom_material: customMaterialSelectName || "",
      customer_description: customerDescription,
      real_time: priceModalItem.real_time,
      time: priceModalItem.time,
      offline: priceModalItem.offline,
      mass: priceModalItem.mass,
    };

    const finalValues = {
      json_process_data: values1,
      general_data: values2,
    };

    try {
      const response = await updateService(user, finalValues, params.id, true);
      if (response.status === 201) {
        toast.success("با موفقیت ارسال شد");
        setLoading(false);
        return navigate("/Quotes");
        // const result = await repriceService(user, params.id, "write");
        // if (result.status === 200 || result.status === 204) {
        // toast.success("با موفقیت ارسال شد");
        // setLoading(false);
        // return navigate("/Quotes");
        // }
        // else if (result.status === 204) {
        //     submitRepricing();
        // }
      } else {
        toast.error(json.toast.err_1);
        setLoading(false);
      }

      // const result = await repriceService(user, params.id, true);
      // if (result.status === 200) {
      //     const response = await updateService(user, finalValues, params.id, true);
      //     if (response.status === 201) {
      //         toast.success("با موفقیت ارسال شد");
      //         setLoading(false);
      //         return navigate("/Quotes");
      //     } else {
      //         toast.error(json.toast.err_1);
      //         setLoading(false);
      //     }
      // } else {
      //     setTimeout(() => {
      //         handleSendData();
      //     }, 3000);
      // }
    } catch (error) {
      toast.error(json.toast.err_1);
      setLoading(false);
    }
  };

  const twoDimensionalMapHandeler = async () => {
    setLocalFileLoading(true);
    var formdata = new FormData();
    formdata.append("map_file_t", twoDimensionalMap);
    formdata.append("code", params.id);
    try {
      const { status } = await putTwoDimensionalMap(user, formdata);
      if (status === 200) {
        toast.success("با موفقیت آپلود شد");
        setLocalFileUploaded(true);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLocalFileLoading(false);
    }
  };

  // Back button
  const handleGoBack = async () => {
    setLoading(true);

    const values1 = {
      ...backupData.process_output,
      technology: backupData.process_output.technology,
      additional_operations: backupData.process_output.additional_operations,
      general_roughness: backupData.process_output.general_roughness,
      plan: backupData.process_output.plan,
      material: backupData.process_output.material,
      custom_material: backupData.service_detail.custom_material || "",
      quantity: backupData.process_output.quantity,
      unit_price: backupPriceModalItem.unit_price,
      unit: backupData.process_output.unit,
      drawing: backupData.process_output.drawing,
      general_geo_tolerance: backupData.process_output.general_geo_tolerance,
      general_dim_tolerance: backupData.process_output.general_dim_tolerance,
      supply: backupData.process_output.supply,
      faces: backupData.process_output.faces,
      has_working_faces: backupData.process_output.has_working_faces,
      working_faces: backupData.process_output.working_faces,
    };

    const values2 = {
      custom_material: backupData.service_detail.custom_material || "",
      customer_description: backupData.service_detail.customer_description,
      real_time: backupPriceModalItem?.real_time,
      time: backupPriceModalItem?.time,
      offline: backupPriceModalItem?.offline,
      mass: backupPriceModalItem?.mass,
    };

    const finalValues = {
      json_process_data: values1,
      general_data: values2,
    };

    try {
      const response = await updateService(user, finalValues, params.id, false);
      if (response.status === 201) {
        return navigate("/Quotes");
      } else {
        toast.error(json.toast.err_1);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const hideButtons = () => {
    const buttons = document
      .getElementsByTagName("iframe")[0]
      .contentWindow.document.getElementsByTagName("button");
    if ([...buttons].length === 0) {
      callHideButtons();
      return;
    }
    for (let btn of buttons) {
      btn.style.display = "none";
    }
  };

  const callHideButtons = () => {
    setTimeout(() => {
      if ([...document.getElementsByTagName("iframe")].length > 0) {
        hideButtons();
      } else {
        callHideButtons();
      }
    }, 500);
  };

  const changeTransparency = () => {
    if ([...document.getElementsByTagName("iframe")].length > 0) {
      const groupFaces = document
        .getElementsByTagName("iframe")[0]
        .contentWindow.document.getElementsByClassName("faces");
      if ([...groupFaces].length > 0) {
        for (let group of groupFaces) {
          const allMaterialsOfGroup = group.getElementsByTagName("material");
          if ([...allMaterialsOfGroup].length > 0) {
            for (let mat of allMaterialsOfGroup) {
              mat.setAttribute("transparency", transparency);
            }
          }
        }
      }
    }
  };

  // useEffect

  useEffect(() => {
    handleGetMaterialPersianGroups();
    servicePriceHandeler();
    getpropertiesHandeler();
    if (location.state) {
      setData(location.state);
      setBackupData(location.state);
      setFacesData(location.state.process_output.faces);
      setHasWorkingFaces(location.state.process_output.has_working_faces);
      setWorkingFaces(location.state.process_output.working_faces);
      setHasErrors(
        location.state.alert.errors.length > 0 ||
        location.pathname.toLowerCase().includes("detailorder")
      );
      setLoading(false);
    } else if (params.id) {
      getOrderDataHandeler();
    } else {
      return;
    }

    return () => {
      clearTimeout(getDataTimeout);
      clearTimeout(repriceTimeout);
      clearTimeout(priceTimeout);
      clearTimeout(searchMaterialTimeout);
      clearInterval(interval);
    };
  }, [location.state, params.id]);

  useEffect(() => {
    if (properties.length > 0 && planSelect === "") {
      setPropertiesTechnology(
        properties.filter((item) => item.type === "technology")
      );
      setPropertiesAdditional(
        properties.filter((item) => item.type === "additional")
      );
      setPropertiesRoughness(
        properties.filter((item) => item.type === "roughness")
      );
      setPropertiesDimTolerance(
        properties.filter((item) => item.type === "dim_tolerance")
      );
      setPropertiesGeoTolerance(
        properties.filter((item) => item.type === "geo_tolerance")
      );
      setPropertiesPlan(properties.filter((item) => item.type === "plan"));
    }
  }, [properties, planSelect]);

  useEffect(() => {
    console.log("this is the data: ", data)
    console.log("this is the rough: ", propertiesRoughness.length)
    console.log("this is the plan: ", planSelect)
    console.log("this is the face: ", facesData.length)
    if (
      data &&
      propertiesRoughness.length > 0 &&
      planSelect === ""
      // facesData.length > 0
    ) {
      setDataHandler();
      if (facesData.length > 0) {
        setInitialFacesValues();
      }
      setTimeout(() => {
        setInitialized(true);
      }, 2000);
    }
  }, [data, propertiesRoughness, planSelect, facesData]);

  useEffect(() => {
    if (priceModalItem) {
      findUnitPriceHandler();
    }
  }, [priceModalItem]);

  useEffect(() => {
    if (
      facesData.length > 0 &&
      propertiesRoughness.length > 0 &&
      !X3DEventAdded
    ) {
      callAddEventToX3D();
    }
  }, [facesData, propertiesRoughness]);

  useEffect(() => {
    if (data && data.x3d) {
      // Hide buttons in mobile view
      callHideButtons();
    }
  }, [data]);

  useEffect(() => {
    const findNoPageAtr = addAtrShape.find((atr) => atr.page.length === 0);
    if (findNoPageAtr) {
      setAddAtrShape((prevValue) =>
        prevValue.filter((atr) => atr.page.length > 0)
      );
    }
  }, [addAtrShape]);

  // useEffect(() => {
  //   if (searchMaterial.length > 0) {
  //     setSearchMaterialLoading(true);
  //     searchMaterialsHandler(
  //       searchMaterial,
  //       materialCategory,
  //       // availableMaterial
  //     );
  //   }
  // }, [searchMaterial, materialCategory]);

  useEffect(() => {
    if (
      data &&
      initialized &&
      !location.pathname.toLowerCase().includes("detailorder") &&
      !stopSendingRequest
    ) {
      repricingHandler(null);
    }
  }, [
    unit,
    technologySelect,
    materialSelect,
    supply,
    workingFaces,
    additionalSelect,
    roughnessSelect,
    dimToleranceSelect,
    geoToleranceSelect,
    facesData,
    planSelect,
    drawing,
  ]);

  useEffect(() => {
    if (
      data &&
      initialized &&
      !location.pathname.toLowerCase().includes("detailorder") &&
      !stopSendingRequest
    ) {
      callRepricingHandler(null);
    }
  }, [number]);

  useEffect(() => {
    changeTransparency();
  }, [transparency]);

  useEffect(() => {
    document.body.addEventListener("click", () => {
      setSearchInput(false);
    });
  }, []);

  useEffect(() => {
    // const getAvailibleMaterialsHandler = async (
    //   category,
    //   availableMaterial
    // ) => {
    //   try {
    //     const response = await getAvailableMaterials(
    //       user,
    //       category,
    //       availableMaterial
    //     );
    //     if (response.status === 200) {
    //       setMaterials({
    //         materials: response.data.results,
    //         pages: response.data.pages,
    //       });
    //       setPageMaterials(2);
    //     }
    //   } catch (error) {
    //     toast.error(json.toast.err_1);
    //   } finally {
    //     setSearchMaterialLoading(false);
    //   }
    // };

    // if (availableMaterial){
    //   setSearchMaterialLoading(true);
    //   getAvailibleMaterialsHandler(materialCategory, availableMaterial)
    // }
    // else{
    // if (searchMaterial) {
    setSearchMaterialLoading(true);
    searchMaterialsHandler(
      searchMaterial,
      materialCategory,
      availableMaterial
    );
    //   }
    // }
  }, [availableMaterial, searchMaterial, materialCategory])

  return (
    <MainLayout>
      {loading ? (
        <div className="d-flex justify-content-center px-2 py-5 h3">
          لطفاً صبر کنید...
        </div>
      ) : data ? (
        <div
          className={
            hasErrors || localFileLoading || repricingLoading
              ? "pointer-none"
              : ""
          }
        >
          {/* Start hovered shape modal */}
          {showHoveredShape && (
            <div
              className={styles.hoveredShapeModal}
              ref={hoveredShapeModalRef}
            >
              <table>
                <thead>
                  <tr>
                    <th>عنوان</th>
                    <th>مقدار</th>
                  </tr>
                </thead>
                <tbody>
                  {hoveredShapeData.map((item, index) => (
                    <tr key={`hovered_item_${index}`}>
                      <td>{item.name}</td>
                      <td>{item.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          {/* End hovered shape modal */}
          <div className="d-flex flex-wrap align-items-start gap-3">
            <div className={styles.orderInformationRight}>
              <section className="pointer-auto">
                <button
                  onClick={() => setTabInformationRight(true)}
                  style={
                    tabInformationRight
                      ? { borderBottom: "solid 5px #0038FF" }
                      : null
                  }
                >
                  {content.title_1}
                </button>
                <button
                  onClick={() => setTabInformationRight(false)}
                  style={
                    tabInformationRight
                      ? null
                      : { borderBottom: "solid 5px #0038FF" }
                  }
                >
                  {content.title_2}
                </button>
              </section>
              {tabInformationRight ? (
                <>
                  <div className="w-100 pointer-auto">
                    {data.alert.warnings.length > 0
                      ? data.alert.warnings.map((item, index) => (
                        <div
                          className="accordion-item main-accordion-item warning"
                          key={index}
                          onMouseOver={() =>
                            highlightShapesHandler(item.faces)
                          }
                          onMouseLeave={() =>
                            unhighlightShapesHandler(item.faces)
                          }
                        >
                          <div
                            className="accordion-header collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#panelsStayOpen-warning-${index}`}
                            aria-expanded="false"
                            aria-controls={`panelsStayOpen-warning-${index}`}
                          >
                            <span className="d-flex align-items-center gap-3">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M22.5237 17.4469L14.3252 3.2091C14.0878 2.80299 13.7481 2.46613 13.34 2.23203C12.932 1.99793 12.4697 1.87476 11.9993 1.87476C11.5288 1.87476 11.0666 1.99793 10.6585 2.23203C10.2505 2.46613 9.91081 2.80299 9.67334 3.2091L1.4749 17.4469C1.24448 17.841 1.12305 18.2893 1.12305 18.7458C1.12305 19.2023 1.24448 19.6506 1.4749 20.0447C1.70974 20.4529 2.04892 20.7912 2.45767 21.025C2.86641 21.2587 3.32999 21.3796 3.80084 21.375H20.1977C20.6683 21.3792 21.1314 21.2582 21.5398 21.0245C21.9482 20.7907 22.2871 20.4526 22.5218 20.0447C22.7525 19.6508 22.8742 19.2026 22.8746 18.7461C22.8749 18.2896 22.7538 17.8412 22.5237 17.4469ZM20.5737 18.9188C20.5355 18.9838 20.4806 19.0372 20.4145 19.0735C20.3485 19.1098 20.2739 19.1276 20.1987 19.125H3.80084C3.72555 19.1276 3.65096 19.1098 3.58495 19.0735C3.51894 19.0372 3.46397 18.9838 3.42584 18.9188C3.3935 18.8662 3.37638 18.8057 3.37638 18.7439C3.37638 18.6822 3.3935 18.6217 3.42584 18.5691L11.6243 4.33129C11.6649 4.2688 11.7204 4.21745 11.7859 4.1819C11.8514 4.14635 11.9248 4.12773 11.9993 4.12773C12.0738 4.12773 12.1471 4.14635 12.2126 4.1819C12.2781 4.21745 12.3337 4.2688 12.3743 4.33129L20.5718 18.5691C20.6044 18.6215 20.6219 18.6819 20.6222 18.7437C20.6225 18.8054 20.6057 18.866 20.5737 18.9188ZM10.8743 12.75V9.75004C10.8743 9.45167 10.9928 9.16552 11.2038 8.95455C11.4148 8.74357 11.7009 8.62504 11.9993 8.62504C12.2976 8.62504 12.5838 8.74357 12.7948 8.95455C13.0058 9.16552 13.1243 9.45167 13.1243 9.75004V12.75C13.1243 13.0484 13.0058 13.3346 12.7948 13.5455C12.5838 13.7565 12.2976 13.875 11.9993 13.875C11.7009 13.875 11.4148 13.7565 11.2038 13.5455C10.9928 13.3346 10.8743 13.0484 10.8743 12.75ZM13.4993 16.5C13.4993 16.7967 13.4113 17.0867 13.2465 17.3334C13.0817 17.5801 12.8474 17.7723 12.5733 17.8859C12.2992 17.9994 11.9976 18.0291 11.7066 17.9712C11.4157 17.9133 11.1484 17.7705 10.9386 17.5607C10.7288 17.3509 10.586 17.0836 10.5281 16.7927C10.4702 16.5017 10.4999 16.2001 10.6135 15.926C10.727 15.6519 10.9192 15.4177 11.1659 15.2528C11.4126 15.088 11.7026 15 11.9993 15C12.3971 15 12.7786 15.1581 13.0599 15.4394C13.3412 15.7207 13.4993 16.1022 13.4993 16.5Z"
                                  fill="#E07900"
                                />
                              </svg>

                              {item.title}
                            </span>
                          </div>
                          <div
                            id={`panelsStayOpen-warning-${index}`}
                            className="accordion-collapse collapse"
                          >
                            <div className="accordion-body">
                              <p>{item.text}</p>
                              <span className={styles.infoColor}>
                                اطلاعات بیشتر و راهکارهای رفع این خطا
                              </span>
                            </div>
                          </div>
                        </div>
                      ))
                      : null}

                    {data.alert.errors.length > 0
                      ? data.alert.errors.map((item, index) => (
                        <div
                          className="accordion-item main-accordion-item error"
                          key={index}
                          onMouseOver={() =>
                            highlightShapesHandler(item.faces)
                          }
                          onMouseLeave={() =>
                            unhighlightShapesHandler(item.faces)
                          }
                        >
                          <div
                            className="accordion-header collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#panelsStayOpen-error-${index}`}
                            aria-expanded="false"
                            aria-controls={`panelsStayOpen-error-${index}`}
                          >
                            <span className="d-flex align-items-center gap-3">
                              <svg
                                width="25"
                                height="24"
                                viewBox="0 0 25 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M12.6829 1.875C10.6276 1.875 8.61844 2.46882 6.9095 3.58137C5.20055 4.69392 3.8686 6.27523 3.08206 8.12533C2.29552 9.97543 2.08972 12.0112 2.4907 13.9753C2.89167 15.9393 3.88141 17.7435 5.33474 19.1595C6.78808 20.5755 8.63974 21.5398 10.6556 21.9305C12.6714 22.3211 14.7609 22.1206 16.6597 21.3543C18.5586 20.5879 20.1816 19.2902 21.3235 17.6251C22.4654 15.9601 23.0749 14.0025 23.0749 12C23.0718 9.3156 21.976 6.74199 20.0278 4.84383C18.0796 2.94567 15.4381 1.87798 12.6829 1.875ZM12.6829 19.875C11.0843 19.875 9.52166 19.4131 8.19248 18.5478C6.86331 17.6825 5.82734 16.4526 5.21559 15.0136C4.60383 13.5747 4.44377 11.9913 4.75564 10.4637C5.06751 8.93606 5.8373 7.53287 6.96767 6.43153C8.09805 5.3302 9.53823 4.58017 11.1061 4.27632C12.674 3.97246 14.2991 4.12841 15.776 4.72445C17.2529 5.32049 18.5152 6.32985 19.4034 7.62488C20.2915 8.91992 20.7655 10.4425 20.7655 12C20.7632 14.0879 19.9109 16.0896 18.3957 17.566C16.8804 19.0424 14.8259 19.8728 12.6829 19.875ZM11.5283 12.375V7.5C11.5283 7.20163 11.6499 6.91548 11.8665 6.7045C12.083 6.49353 12.3767 6.375 12.6829 6.375C12.9892 6.375 13.2829 6.49353 13.4994 6.7045C13.7159 6.91548 13.8376 7.20163 13.8376 7.5V12.375C13.8376 12.6734 13.7159 12.9595 13.4994 13.1705C13.2829 13.3815 12.9892 13.5 12.6829 13.5C12.3767 13.5 12.083 13.3815 11.8665 13.1705C11.6499 12.9595 11.5283 12.6734 11.5283 12.375ZM14.2225 16.125C14.2225 16.4217 14.1322 16.7117 13.963 16.9584C13.7939 17.205 13.5534 17.3973 13.2721 17.5108C12.9908 17.6244 12.6812 17.6541 12.3826 17.5962C12.0839 17.5383 11.8096 17.3954 11.5943 17.1857C11.379 16.9759 11.2324 16.7086 11.173 16.4176C11.1136 16.1267 11.1441 15.8251 11.2606 15.551C11.3771 15.2769 11.5744 15.0426 11.8276 14.8778C12.0808 14.713 12.3784 14.625 12.6829 14.625C13.0912 14.625 13.4828 14.783 13.7716 15.0643C14.0603 15.3456 14.2225 15.7272 14.2225 16.125Z"
                                  fill="#FF0000"
                                />
                              </svg>
                              {item.title}
                            </span>
                          </div>
                          <div
                            id={`panelsStayOpen-error-${index}`}
                            className="accordion-collapse collapse"
                          >
                            <div className="accordion-body">
                              <p>{item.text}</p>
                              <span className={styles.infoColor}>
                                اطلاعات بیشتر و راهکارهای رفع این خطا
                              </span>
                            </div>
                          </div>
                        </div>
                      ))
                      : null}
                  </div>

                  <div className="d-flex flex-row justify-content-between flex-wrap">
                    <div className="d-flex gap-3 align-items-center">
                      <p>واحد : </p>
                      <div className="d-flex gap-3">
                        <button
                          onClick={() => {
                            setUnit("mm");
                          }}
                          className={
                            unit === "mm"
                              ? "main-btn main-btn-fill"
                              : "main-btn main-btn-outline"
                          }
                        >
                          mm
                        </button>
                        <button
                          disabled={true}
                          onClick={() => {
                            setUnit("inch");
                          }}
                          className={
                            unit === "inch"
                              ? "main-btn main-btn-fill"
                              : "main-btn main-btn-outline disabled"
                          }
                        >
                          inch
                        </button>
                      </div>
                    </div>
                    <div className="d-flex gap-3 align-items-center">
                      <p>ابعاد:</p>
                      <div className="input-frame input-frame-two d-flex justify-content-center">
                        <span className={styles.showDimensions}>
                          {dimensions || "length x width x height"}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className={styles.selectItem}>
                    <div>
                      <p>{content.selectItem_1.label}</p>
                      <a
                        href="https://wisercam.com/guide/services/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {content.selectItem_1.guide}
                      </a>
                    </div>
                    <div className="input-frame input-frame-two">
                      <select
                        id="CNC"
                        onChange={(e) => {
                          setTechnologySelect(e.target.value);
                        }}
                      >
                        <option className="d-none">
                          {propertiesTechnology.find(
                            (item) => item.value == technologySelect
                          )?.slug || "یک مورد را انتخاب کنید"}
                        </option>
                        {propertiesTechnology.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.slug}
                          </option>
                        ))}
                      </select>
                    </div>
                    <span className={styles.infoColor}>
                      {content.selectItem_1.moreinfo}
                    </span>
                  </div>

                  <div className={styles.selectItem}>
                    <div>
                      <p>{content.selectItem_2.label}</p>
                      <a
                        href="https://wisercam.com/guide/material-guide/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {content.selectItem_2.guide}
                      </a>
                    </div>
                    <div className="search-input-frame">
                      <div
                        onClick={(ev) => {
                          ev.stopPropagation();
                          setSearchInput(true);
                        }}
                        className="input-frame input-frame-two justify-content-between"
                      >
                        <span
                          style={{
                            flex: "1",
                          }}
                        >
                          {materialSelect ? (
                            <span className="d-flex flex-column px-1">
                              <span style={{ fontWeight: "bold" }}>
                                {materialSelect["persian_class"]}
                              </span>
                              <span style={{ direction: "ltr" }}>
                                {materialFields
                                  .map((field) => {
                                    return materialSelect[field] &&
                                      materialSelect[field] !== "-"
                                      ? field === "wnr"
                                        ? `${Number(
                                          materialSelect[field]
                                        ).toFixed(4)}`
                                        : `${materialSelect[field]}`
                                      : "";
                                  })
                                  .filter((m) => m !== "")
                                  .join(" \\ ")}
                              </span>
                            </span>
                          ) : (
                            "یک مورد را انتخاب کنید"
                          )}
                        </span>
                        <span
                          className={
                            materialSelect?.cost > 0 ? "green-card" : "red-card"
                          }
                        >
                          {materialSelect?.cost > 0 ? "موجود" : "ناموجود"}
                        </span>
                      </div>
                      <div
                        className={
                          searchInput ? "search-input active" : "search-input"
                        }
                        onClick={(ev) => ev.stopPropagation()}
                      >
                        <div className="w-100 mb-2">
                          <select
                            onChange={(ev) =>
                              setMaterialCategory(ev.target.value)
                            }
                            className="select-material"
                          >
                            <option value="">همه گروه‌ها</option>
                            {materialCategoryOptions.map((item, index) => (
                              <option
                                value={item}
                                key={`material_group_${index}`}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <input
                            type="radio"
                            value="true"
                            className="ml-2 mt-3 mb-2"
                            checked={availableMaterial === true}
                            onChange={() => {
                              handleSetSearchMaterial("")
                              setAvailableMaterial(true)
                            }}
                          />
                          <label>فقط مواد موجود</label>
                          <br></br>
                          <input
                            type="radio"
                            value="true"
                            className="ml-1 mt-2 mb-2"
                            checked={availableMaterial === false}
                            onChange={() => {
                              handleSetSearchMaterial("")
                              setAvailableMaterial(false)
                            }}
                          />
                          <label>جست‌و‌جو در دیتابیس</label>
                        </div>

                        {!availableMaterial ? (
                          <>
                            <div className="input-frame border shadow-1 mt-3">
                              <span className="main-btn-icon main-btn-fill">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  fill="currentColor"
                                  className="bi bi-search"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                </svg>
                              </span>
                              <input
                                onChange={(e) =>
                                  handleSetSearchMaterial(e.target.value)
                                }
                                type="text"
                                name="search"
                                placeholder="جنس قطعه را وارد کنید"
                              />
                            </div>
                            {searchMaterialLoading ? (
                              <div className="pt-4 text-center">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="sr-only"></span>
                                </div>
                              </div>
                            ) : materials ? (
                              searchMaterial.length > 0 ? (
                                materials.materials.length > 0 ? (
                                  <div
                                    className="res-search"
                                    onScroll={(e) => handleScroll(e)}
                                  >
                                    {materials.materials.map((item, index) => (
                                      <p
                                        key={`material_${index}`}
                                        onClick={() => {
                                          setSearchInput(false);
                                          setMaterialSelect(item);
                                          setSupply((prevValue) => {
                                            if (
                                              !Boolean(item.cost) ||
                                              customMaterialSelect ||
                                              Boolean(hasWorkingFaces)
                                            ) {
                                              return 0;
                                            }
                                            return prevValue;
                                          });
                                        }}
                                      >
                                        {
                                          <span className="d-flex flex-column px-1">
                                            <span style={{ fontWeight: "bold" }}>
                                              {item["persian_class"]}
                                            </span>
                                            <span style={{ direction: "ltr" }}>
                                              {materialFields
                                                .map((field) => {
                                                  return item[field] &&
                                                    item[field] !== "-"
                                                    ? field === "wnr"
                                                      ? `${Number(
                                                        item[field]
                                                      ).toFixed(4)}`
                                                      : `${item[field]}`
                                                    : "";
                                                })
                                                .filter((m) => m !== "")
                                                .join(" \\ ")}
                                            </span>
                                          </span>
                                        }
                                      </p>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="pt-3 px-1">موردی یافت نشد</div>
                                )
                              ) : (
                                <div
                                  className="pt-3 px-1"
                                  style={{ fontSize: "0.9rem" }}
                                >
                                  برای مشاهده‌ی جنس قطعه، ماده‌ی مورد نیاز را جست و
                                  جو کنید
                                </div>
                              )
                            ) : (
                              <div
                                className="pt-3 px-1"
                                style={{ fontSize: "0.9rem" }}
                              >
                                برای مشاهده‌ی جنس قطعه، ماده‌ی مورد نیاز را جست و جو
                                کنید
                              </div>
                            )}
                          </>
                        ) : (
                          materials ? (
                            <div
                              className="res-search"
                              onScroll={(e) => handleScroll(e)}
                              mt-3
                            >
                              {materials.materials.map((item, index) => (
                                <p
                                  key={`material_${index}`}
                                  onClick={() => {
                                    setSearchInput(false);
                                    setMaterialSelect(item);
                                    setSupply((prevValue) => {
                                      if (
                                        !Boolean(item.cost) ||
                                        customMaterialSelect ||
                                        Boolean(hasWorkingFaces)
                                      ) {
                                        return 0;
                                      }
                                      return prevValue;
                                    });
                                  }}
                                >
                                  {
                                    <span className="d-flex flex-column px-1">
                                      <span style={{ fontWeight: "bold" }}>
                                        {item["persian_class"]}
                                      </span>
                                      <span style={{ direction: "ltr" }}>
                                        {materialFields
                                          .map((field) => {
                                            return item[field] &&
                                              item[field] !== "-"
                                              ? field === "wnr"
                                                ? `${Number(
                                                  item[field]
                                                ).toFixed(4)}`
                                                : `${item[field]}`
                                              : "";
                                          })
                                          .filter((m) => m !== "")
                                          .join(" \\ ")}
                                      </span>
                                    </span>
                                  }
                                </p>
                              ))}
                            </div>
                          ) : (
                            <div className="pt-3 px-1">موردی یافت نشد</div>
                          ))}

                      </div>
                    </div>
                    <a
                      href={materialSelect?.link || ""}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {content.selectItem_2.moreinfo}
                    </a>
                  </div>
                  <div>
                    <div className="d-flex gap-2 align-items-center">
                      <input
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSupply(0);
                          }
                          if (!e.target.checked) {
                            setCustomMaterialSelectName("");
                            if (
                              !(
                                !Boolean(materialSelect?.cost) ||
                                Boolean(hasWorkingFaces)
                              )
                            ) {
                              setSupply(pureSupply);
                            }
                          }
                          setCustomMaterialSelect(e.target.checked);
                        }}
                        checked={customMaterialSelect}
                        type="checkbox"
                        id="vehicle1"
                        name="vehicle1"
                      />
                      <label htmlFor="vehicle1">نام ماده در لیست نیست</label>
                    </div>
                    {customMaterialSelect && (
                      <div className="w-100">
                        <p>نام ماده :</p>
                        <div className="input-frame input-frame-two w-100">
                          <input
                            value={customMaterialSelectName}
                            onChange={(e) =>
                              setCustomMaterialSelectName(e.target.value)
                            }
                            placeholder="نام ماده را وارد کنید"
                            className="w-100"
                          />
                        </div>
                      </div>
                    )}
                    <div className="d-flex gap-2 align-items-center">
                      <input
                        onChange={(e) => {
                          if (
                            customMaterialSelect ||
                            !Boolean(materialSelect?.cost) ||
                            Boolean(hasWorkingFaces)
                          ) {
                            e.preventDefault();
                          } else {
                            setSupply(e.target.checked ? 0 : 1);
                            setPureSupply(e.target.checked ? 0 : 1);
                          }
                        }}
                        checked={
                          supply == 0 ||
                          customMaterialSelect ||
                          !Boolean(materialSelect?.cost) ||
                          Boolean(hasWorkingFaces)
                        }
                        type="checkbox"
                        id="vehicle2"
                        name="vehicle2"
                      />
                      <label htmlFor="vehicle2">
                        {" "}
                        تامین ماده اولیه توسط مشتری
                      </label>
                    </div>
                  </div>

                  {offlineFileFormat == 0 && (
                    <div className={styles.selectItem}>
                      <div>
                        <div className="d-flex gap-2 align-items-center">
                          <input
                            type="checkbox"
                            id="vehicle3"
                            name="vehicle3"
                            checked={hasWorkingFaces == 1}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSupply(0);
                              } else {
                                handleDeleteWorkingFaces();
                                if (
                                  !(
                                    customMaterialSelect ||
                                    !Boolean(materialSelect?.cost)
                                  )
                                ) {
                                  setSupply(pureSupply);
                                }
                              }
                              setHasWorkingFaces(e.target.checked ? 1 : 0);
                            }}
                          />
                          <label htmlFor="vehicle3">
                            {" "}
                            ماشینکاری قطعات ریخته‌گری یا نیمه آماده{" "}
                          </label>
                        </div>
                        <a
                          href="https://wisercam.com/guide/secondary-process-guide/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          راهنما
                        </a>
                      </div>
                      {hasWorkingFaces == 1 ? (
                        <div>
                          {workingFaces.length > 0 ? (
                            <div
                              className="w-100 mb-2 background-gray 
                                                    rounded-global py-2 px-2 border1-black
                                                    d-flex justify-content-between align-items-center"
                            >
                              <div>
                                تعداد سطوح ماشینکاری: {workingFaces.length}
                              </div>
                              {offlineFileFormat == 0 && (
                                <div
                                  className="d-flex justify-content-center
                                                            align-items-center"
                                >
                                  <span
                                    className="cursor-pointer mx-2"
                                    onClick={handleEditWorkingFaces}
                                  >
                                    <svg
                                      width="25px"
                                      height="25px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M20.8477 1.87868C19.6761 0.707109 17.7766 0.707105 16.605 1.87868L2.44744 16.0363C2.02864 16.4551 1.74317 16.9885 1.62702 17.5692L1.03995 20.5046C0.760062 21.904 1.9939 23.1379 3.39334 22.858L6.32868 22.2709C6.90945 22.1548 7.44285 21.8693 7.86165 21.4505L22.0192 7.29289C23.1908 6.12132 23.1908 4.22183 22.0192 3.05025L20.8477 1.87868ZM18.0192 3.29289C18.4098 2.90237 19.0429 2.90237 19.4335 3.29289L20.605 4.46447C20.9956 4.85499 20.9956 5.48815 20.605 5.87868L17.9334 8.55027L15.3477 5.96448L18.0192 3.29289ZM13.9334 7.3787L3.86165 17.4505C3.72205 17.5901 3.6269 17.7679 3.58818 17.9615L3.00111 20.8968L5.93645 20.3097C6.13004 20.271 6.30784 20.1759 6.44744 20.0363L16.5192 9.96448L13.9334 7.3787Z"
                                        fill="#0F0F0F"
                                      />
                                    </svg>
                                  </span>
                                  <span
                                    className="cursor-pointer mx-2"
                                    onClick={handleDeleteWorkingFaces}
                                  >
                                    <svg
                                      width="25px"
                                      height="25px"
                                      viewBox="0 -0.5 21 21"
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      xlink="http://www.w3.org/1999/xlink"
                                    >
                                      <title>delete [#1487]</title>
                                      <desc>Created with Sketch.</desc>
                                      <defs></defs>
                                      <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                      >
                                        <g
                                          id="Dribbble-Light-Preview"
                                          transform="translate(-179.000000, -360.000000)"
                                          fill="#000000"
                                        >
                                          <g
                                            id="icons"
                                            transform="translate(56.000000, 160.000000)"
                                          >
                                            <path
                                              d="M130.35,216 L132.45,216 L132.45,208 L130.35,208 L130.35,216 Z M134.55,216 L136.65,216 L136.65,208 L134.55,208 L134.55,216 Z M128.25,218 L138.75,218 L138.75,206 L128.25,206 L128.25,218 Z M130.35,204 L136.65,204 L136.65,202 L130.35,202 L130.35,204 Z M138.75,204 L138.75,200 L128.25,200 L128.25,204 L123,204 L123,206 L126.15,206 L126.15,220 L140.85,220 L140.85,206 L144,206 L144,204 L138.75,204 Z"
                                              id="delete-[#1487]"
                                            ></path>
                                          </g>
                                        </g>
                                      </g>
                                    </svg>
                                  </span>
                                </div>
                              )}
                            </div>
                          ) : (
                            <div className=" w-100 mb-2 flex flex-column">
                              ابتدا سطوح مورد نظر را انتخاب و سپس تایید کنید.
                              <button
                                className="d-block w-75 mt-2 px-2 py-1
                                                            text-center text-white bg-primary rounded-global"
                                onClick={HandleSetWorkingFaces}
                              >
                                تایید
                              </button>
                            </div>
                          )}
                        </div>
                      ) : null}
                    </div>
                  )}

                  <div className={styles.selectItem}>
                    <div>
                      <p>{content.selectItem_3.label}</p>
                      <span className={styles.infoColor}>
                        <a href="https://wisercam.com/guide/surface-finish/">
                          {content.selectItem_3.guide}
                        </a>
                      </span>
                    </div>

                    <div className="input-frame input-frame-two">
                      <select
                        id="CNC"
                        onChange={(e) => {
                          setAdditionalSelect(e.target.value);
                        }}
                      >
                        <option className="d-none">
                          {additionalSelect
                            ? propertiesAdditional.find(
                              (item) => item.value == additionalSelect
                            )?.slug
                            : "یک مورد را انتخاب کنید"}
                        </option>
                        {propertiesAdditional.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.slug}
                          </option>
                        ))}
                      </select>
                    </div>
                    <span className={styles.infoColor}>
                      {content.selectItem_3.moreinfo}
                    </span>
                  </div>

                  <div className={styles.selectItem}>
                    <div>
                      <p>{content.selectItem_4.label}</p>
                      <a
                        href="https://wisercam.com/guide/roughness/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {content.selectItem_4.guide}
                      </a>
                    </div>
                    <div className="input-frame input-frame-two">
                      <select
                        id="CNC"
                        onChange={(e) => {
                          setValueForAllFaces("roughness", e.target.value);
                        }}
                      >
                        <option className="d-none">
                          {roughnessSelect
                            ? propertiesRoughness.find(
                              (item) => item.value == roughnessSelect
                            )?.slug
                            : "یک مورد را انتخاب کنید"}
                        </option>
                        {propertiesRoughness.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.slug}
                          </option>
                        ))}
                      </select>
                    </div>
                    <span className={styles.infoColor}>
                      {content.selectItem_4.moreinfo}
                    </span>
                  </div>

                  <div className={styles.selectItem}>
                    <div>
                      <p>تلورانس ابعادی عمومی:</p>
                      <a
                        href="https://wisercam.com/guide/dimensional-tolerances-guide/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        راهنمای انتخاب تلورانس ابعادی
                      </a>
                    </div>
                    <div className="input-frame input-frame-two">
                      <select
                        id="CNC"
                        onChange={(e) => {
                          setValueForAllFaces("dim_tolerance", e.target.value);
                        }}
                      >
                        <option className="d-none">
                          {dimToleranceSelect
                            ? propertiesDimTolerance.find(
                              (item) => item.value == dimToleranceSelect
                            )?.slug
                            : "یک مورد را انتخاب کنید"}
                        </option>
                        {propertiesDimTolerance.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.slug}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className={styles.selectItem}>
                    <div>
                      <p>تلورانس هندسی عمومی:</p>
                      <a
                        href="https://wisercam.com/guide/geometric-tolerances-guide/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        راهنمای انتخاب تلورانس هندسی
                      </a>
                    </div>
                    <div className="input-frame input-frame-two">
                      <select
                        id="CNC"
                        onChange={(e) => {
                          setValueForAllFaces("geo_tolerance", e.target.value);
                        }}
                      >
                        <option className="d-none">
                          {geoToleranceSelect
                            ? propertiesGeoTolerance.find(
                              (item) => item.value == geoToleranceSelect
                            )?.slug
                            : "یک مورد را انتخاب کنید"}
                        </option>
                        {propertiesGeoTolerance.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.slug}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </>
              ) : (
                // تنظیمات محلی
                <>
                  <div className={styles.selectradio}>
                    <div>
                      <div>
                        <input
                          checked={
                            offlineFileFormat == 1 ? false : drawing == 0
                          }
                          disabled={offlineFileFormat == 1}
                          onChange={() => {
                            setUploadModal(true);
                            setDrawing(0);
                          }}
                          type="radio"
                          id="html"
                          name="fav_language"
                          value={content.radioItem_1.label}
                        />
                        <label htmlFor="html">
                          {content.radioItem_1.label}
                        </label>
                      </div>
                      <a
                        href="https://wisercam.com/guide/design-parameters-on-cad/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {content.radioItem_1.guide}
                      </a>
                    </div>
                    <div>
                      <div>
                        <input
                          checked={offlineFileFormat == 1 ? true : drawing == 1}
                          onChange={() => {
                            setUploadModal(false);
                            setDrawing(1);
                          }}
                          type="radio"
                          id="10"
                          name="fav_language"
                          value={content.radioItem_2.label}
                        />
                        <label htmlFor="10">{content.radioItem_2.label}</label>
                      </div>
                      <a
                        href="https://wisercam.com/guide/design-parameters-on-drawing/"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {content.radioItem_2.guide}
                      </a>
                    </div>
                    {uploadModal && (
                      <>
                        <p className="color-danger">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                              fill="#FF0000"
                            />
                          </svg>
                          <span className="mx-1">
                            در صورتی که قطعه دارای رزوه یا انطباق است، در این
                            قسمت باید مشخص گردد. در غیر اینصورت، قطعه به صورت
                            بدون رزوه یا انطباق در نظر گرفته خواهد شد.
                          </span>
                        </p>
                        <p className="color-info d-flex gap-2">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                              fill="#367CFF"
                            />
                          </svg>
                          <span>
                            با انتخاب سطوح بر روی مدل سه‌بعدی، پارامترهای مورد
                            نیاز را تغییر دهید.
                          </span>
                        </p>
                      </>
                    )}
                  </div>
                  {uploadModal ? (
                    <>
                      <div className={styles.orderPreviewImgAttr}>
                        {/* <div>
                          <div className={styles.orderPreviewImgAttrRadio}>
                            <input
                              type="checkbox"
                              id="select3D_1"
                              name="select3D"
                              checked={isSelectedAllFeatures}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  allFeaturesHandler();
                                } else {
                                  setIsSelectedAllFeatures(false);
                                  setIsSelectedSimilarShapes(false);
                                  if (
                                    [...document.getElementsByTagName("iframe")]
                                      .length === 0
                                  ) {
                                    return;
                                  }
                                  document
                                    .getElementsByTagName("iframe")[0]
                                    .contentWindow.document.getElementById(
                                      "deselectAll"
                                    )
                                    .click();
                                }
                                handleSetFacesOptions();
                              }}
                            />
                            <label htmlFor="select3D_1">
                              {content.imgAttrRadio[0].title}
                            </label>
                          </div> */}
                        {/* All Shape input start */}
                        {/* <div className={styles.orderPreviewImgAttrRadio}>
                            <input
                              type="checkbox"
                              id="selectAllShapeCheckbox"
                              name="selectAllShape"
                              checked={isSelectedAllShapes}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  selectAllShapesHandler();
                                  setIsSelectedAllShapes(true);
                                } else {
                                  setIsSelectedAllFeatures(false);
                                  setIsSelectedAllShapes(false);
                                  setIsSelectedAllFeatures(false);
                                  if (
                                    [...document.getElementsByTagName("iframe")]
                                      .length === 0
                                  ) {
                                    return;
                                  }
                                  document
                                    .getElementsByTagName("iframe")[0]
                                    .contentWindow.document.getElementById(
                                      "deselectAll"
                                    )
                                    .click();
                                }
                                handleSetFacesOptions();
                              }}
                            />
                            <label htmlFor="select3D_1">
                              {content.imgAttrRadio[2].title}
                            </label>
                          </div> */}
                        {/* All Shape input end */}

                        {/* <div className={styles.orderPreviewImgAttrRadio}>
                            <input
                              type="checkbox"
                              id="select3D_2"
                              name="select3D"
                              checked={isSelectedSimilarShapes}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  similarHandler();
                                } else {
                                  setIsSelectedSimilarShapes(false);
                                  setIsSelectedAllFeatures(false);
                                  if (
                                    [...document.getElementsByTagName("iframe")]
                                      .length === 0
                                  ) {
                                    return;
                                  }
                                  document
                                    .getElementsByTagName("iframe")[0]
                                    .contentWindow.document.getElementById(
                                      "deselectAll"
                                    )
                                    .click();
                                }
                                handleSetFacesOptions();
                              }}
                            />

                            <label htmlFor="select3D_2">
                              {content.imgAttrRadio[1].title}
                            </label>
                          </div>
                        </div> */}
                        <div>
                          <div>
                            <p>انطباق</p>
                            <div className="input-frame input-frame-two">
                              <select
                                id="CNC"
                                value="select"
                                onChange={(e) => {
                                  editJsonShowAndFacesHandler(
                                    "fit",
                                    e.target.value
                                  );
                                }}
                                disabled={
                                  isDisabled ||
                                  isAllFieldsDisabled ||
                                  fitOptions.length === 0
                                }
                              // onMouseDown={(ev) => {
                              //     if(fitOptions.length === 0) {
                              //         toast.error("صفحه‌ای را انتخاب نکردید")
                              //         ev.preventDefault();
                              //     }
                              // }}
                              >
                                <option className="d-none" value="select">
                                  انتخاب کنید
                                </option>
                                {fitOptions.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.slug}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div>
                            <p>رزوه</p>
                            <div className="input-frame input-frame-two">
                              <select
                                id="CNC"
                                value="select"
                                onChange={(e) => {
                                  editJsonShowAndFacesHandler(
                                    "thread",
                                    e.target.value
                                  );
                                }}
                                disabled={
                                  isDisabled ||
                                  isAllFieldsDisabled ||
                                  threadOptions.length === 0
                                }
                              // onMouseDown={(ev) => {
                              //     if(threadOptions.length === 0) {
                              //         toast.error("صفحه‌ای را انتخاب نکردید")
                              //         ev.preventDefault();
                              //     }
                              // }}
                              >
                                <option className="d-none" value="select">
                                  انتخاب کنید
                                </option>
                                {threadOptions.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.slug}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div>
                            <p>زبری سطح</p>
                            <div className="input-frame input-frame-two">
                              <select
                                id="CNC"
                                value="select"
                                onChange={(e) => {
                                  editJsonShowAndFacesHandler(
                                    "roughness",
                                    e.target.value
                                  );
                                }}
                                disabled={isAllFieldsDisabled}
                              >
                                <option className="d-none" value="select">
                                  انتخاب کنید
                                </option>
                                {propertiesRoughness.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.slug}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div>
                            <p>دقت ابعادی</p>
                            <div className="input-frame input-frame-two">
                              <select
                                id="CNC"
                                value="select"
                                onChange={(e) => {
                                  editJsonShowAndFacesHandler(
                                    "dim_tolerance",
                                    e.target.value
                                  );
                                }}
                                disabled={isAllFieldsDisabled}
                              >
                                <option className="d-none" value="select">
                                  انتخاب کنید
                                </option>
                                {propertiesDimTolerance.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.slug}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <div>
                            <p>دقت هندسی</p>
                            <div className="input-frame input-frame-two">
                              <select
                                id="CNC"
                                value="select"
                                onChange={(e) => {
                                  editJsonShowAndFacesHandler(
                                    "geo_tolerance",
                                    e.target.value
                                  );
                                }}
                                disabled={isAllFieldsDisabled}
                              >
                                <option className="d-none" value="select">
                                  انتخاب کنید
                                </option>
                                {propertiesGeoTolerance.map((item, index) => (
                                  <option key={index} value={item.value}>
                                    {item.slug}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={styles.completeList}>
                        <div>
                          <p>لیست پارامترها</p>
                        </div>
                        <div className={styles.completeListContainer}>
                          {addAtrShape.length > 0 ? (
                            addAtrShape.map((item, index) => {
                              return item.page.length > 0 ? (
                                <div
                                  className={styles.completeListItem}
                                  key={index}
                                  onMouseOver={() =>
                                    highlightShapesHandler(item.page)
                                  }
                                  onMouseLeave={() =>
                                    unhighlightShapesHandler(item.page)
                                  }
                                >
                                  <p>{item.name}</p>
                                  <p>{item.value}</p>
                                  <div>
                                    {(item.name == "زبری سطح" &&
                                      item.value ===
                                      propertiesRoughness.find(
                                        (p) => p.value == roughnessSelect
                                      )?.slug) ||
                                      (item.name == "دقت ابعادی" &&
                                        item.value ===
                                        propertiesDimTolerance.find(
                                          (p) => p.value == dimToleranceSelect
                                        )?.slug) ||
                                      (item.name == "دقت هندسی" &&
                                        item.value ===
                                        propertiesGeoTolerance.find(
                                          (p) => p.value == geoToleranceSelect
                                        )?.slug) ? null : (
                                      <button
                                        className={`${repricingLoading ? "pointer-none" : ""
                                          }`}
                                        onClick={() => {
                                          handleDeleteItemFromFaces(item);
                                        }}
                                      >
                                        <svg
                                          width="32"
                                          height="32"
                                          viewBox="0 0 32 32"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M27 6H22.5V4.5C22.5 3.57174 22.1313 2.6815 21.4749 2.02513C20.8185 1.36875 19.9283 1 19 1H13C12.0717 1 11.1815 1.36875 10.5251 2.02513C9.86875 2.6815 9.5 3.57174 9.5 4.5V6H5C4.60218 6 4.22064 6.15804 3.93934 6.43934C3.65804 6.72064 3.5 7.10218 3.5 7.5C3.5 7.89782 3.65804 8.27936 3.93934 8.56066C4.22064 8.84196 4.60218 9 5 9H5.5V26C5.5 26.663 5.76339 27.2989 6.23223 27.7678C6.70107 28.2366 7.33696 28.5 8 28.5H24C24.663 28.5 25.2989 28.2366 25.7678 27.7678C26.2366 27.2989 26.5 26.663 26.5 26V9H27C27.3978 9 27.7794 8.84196 28.0607 8.56066C28.342 8.27936 28.5 7.89782 28.5 7.5C28.5 7.10218 28.342 6.72064 28.0607 6.43934C27.7794 6.15804 27.3978 6 27 6ZM12.5 4.5C12.5 4.36739 12.5527 4.24021 12.6464 4.14645C12.7402 4.05268 12.8674 4 13 4H19C19.1326 4 19.2598 4.05268 19.3536 4.14645C19.4473 4.24021 19.5 4.36739 19.5 4.5V6H12.5V4.5ZM23.5 25.5H8.5V9H23.5V25.5ZM14.5 13V21C14.5 21.3978 14.342 21.7794 14.0607 22.0607C13.7794 22.342 13.3978 22.5 13 22.5C12.6022 22.5 12.2206 22.342 11.9393 22.0607C11.658 21.7794 11.5 21.3978 11.5 21V13C11.5 12.6022 11.658 12.2206 11.9393 11.9393C12.2206 11.658 12.6022 11.5 13 11.5C13.3978 11.5 13.7794 11.658 14.0607 11.9393C14.342 12.2206 14.5 12.6022 14.5 13ZM20.5 13V21C20.5 21.3978 20.342 21.7794 20.0607 22.0607C19.7794 22.342 19.3978 22.5 19 22.5C18.6022 22.5 18.2206 22.342 17.9393 22.0607C17.658 21.7794 17.5 21.3978 17.5 21V13C17.5 12.6022 17.658 12.2206 17.9393 11.9393C18.2206 11.658 18.6022 11.5 19 11.5C19.3978 11.5 19.7794 11.658 20.0607 11.9393C20.342 12.2206 20.5 12.6022 20.5 13Z"
                                            fill="black"
                                          />
                                        </svg>
                                      </button>
                                    )}

                                    <p className="main-btn main-btn-fill">
                                      {item.page.length}
                                    </p>
                                  </div>
                                </div>
                              ) : null;
                            })
                          ) : (
                            <div className={styles.completeListItem}>
                              <p>موردی وجود ندارد</p>
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="input-frame">
                        <p>{content.description}</p>
                        <textarea
                          className="px-2 py-1 bg-white"
                          value={customerDescription}
                          style={{
                            resize: "none",
                          }}
                          onChange={(e) =>
                            setCustomerDescription(e.target.value)
                          }
                        ></textarea>
                      </div>
                    </>
                  ) : (
                    <div>
                      <p>آپلود نقشه دو بعدی قطعه:</p>
                      <p className="color-info flex items-start gap-2">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.125 7.875C10.125 7.57833 10.213 7.28832 10.3778 7.04165C10.5426 6.79497 10.7769 6.60271 11.051 6.48918C11.3251 6.37565 11.6267 6.34594 11.9176 6.40382C12.2086 6.4617 12.4759 6.60456 12.6857 6.81434C12.8954 7.02412 13.0383 7.29139 13.0962 7.58236C13.1541 7.87334 13.1244 8.17494 13.0108 8.44903C12.8973 8.72311 12.705 8.95738 12.4584 9.1222C12.2117 9.28703 11.9217 9.375 11.625 9.375C11.2272 9.375 10.8456 9.21696 10.5643 8.93566C10.283 8.65436 10.125 8.27282 10.125 7.875ZM22.125 12C22.125 14.0025 21.5312 15.9601 20.4186 17.6251C19.3061 19.2902 17.7248 20.5879 15.8747 21.3543C14.0246 22.1206 11.9888 22.3211 10.0247 21.9305C8.06066 21.5398 6.25656 20.5755 4.84055 19.1595C3.42454 17.7435 2.46023 15.9393 2.06955 13.9753C1.67888 12.0112 1.87939 9.97543 2.64572 8.12533C3.41206 6.27523 4.70981 4.69392 6.37486 3.58137C8.0399 2.46882 9.99747 1.875 12 1.875C14.6844 1.87798 17.258 2.94567 19.1562 4.84383C21.0543 6.74199 22.122 9.3156 22.125 12ZM19.875 12C19.875 10.4425 19.4131 8.91992 18.5478 7.62488C17.6825 6.32985 16.4526 5.32049 15.0136 4.72445C13.5747 4.12841 11.9913 3.97246 10.4637 4.27632C8.93607 4.58017 7.53288 5.3302 6.43154 6.43153C5.3302 7.53287 4.58018 8.93606 4.27632 10.4637C3.97246 11.9913 4.12841 13.5747 4.72445 15.0136C5.32049 16.4526 6.32985 17.6825 7.62489 18.5478C8.91993 19.4131 10.4425 19.875 12 19.875C14.0879 19.8728 16.0896 19.0424 17.566 17.566C19.0424 16.0896 19.8728 14.0879 19.875 12ZM13.125 15.4387V12.375C13.125 11.8777 12.9275 11.4008 12.5758 11.0492C12.2242 10.6975 11.7473 10.5 11.25 10.5C10.9843 10.4996 10.7271 10.5932 10.5238 10.7643C10.3206 10.9354 10.1844 11.173 10.1395 11.4348C10.0946 11.6967 10.1438 11.966 10.2784 12.195C10.413 12.4241 10.6244 12.5981 10.875 12.6863V15.75C10.875 16.2473 11.0725 16.7242 11.4242 17.0758C11.7758 17.4275 12.2527 17.625 12.75 17.625C13.0157 17.6254 13.2729 17.5318 13.4762 17.3607C13.6794 17.1896 13.8156 16.952 13.8605 16.6902C13.9054 16.4283 13.8562 16.159 13.7216 15.93C13.587 15.7009 13.3756 15.5269 13.125 15.4387Z"
                            fill="#367CFF"
                          />
                        </svg>
                        <span>
                          در صورت آپلود نقشه، بررسی به صورت آفلاین و توسط
                          کارشناسان انجام ‌می‌شود و نتیجه‌ی آن طی 48 ساعت کاری
                          به شما اعلام خواهد شد.
                        </span>
                      </p>

                      {localFileLoading ? (
                        <div className="w-100 py-4 d-flex flex-column justify-content-center align-items-center">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                          <span
                            className="text-primary mt-2"
                            style={{ fontSize: "0.9rem" }}
                          >
                            در حال آپلود فایل...
                          </span>
                        </div>
                      ) : (
                        <>
                          <label
                            className="main-btn main-btn-fill w-100"
                            htmlFor="map_file_input"
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            {content.uploadModal.button}
                            <svg
                              width="32"
                              height="33"
                              viewBox="0 0 32 33"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M32 20.6108V29.5704C32 30.4191 31.6629 31.233 31.0627 31.8331C30.4626 32.4331 29.6487 32.7703 28.8 32.7703H3.2C2.35131 32.7703 1.53737 32.4331 0.937258 31.8331C0.337142 31.233 0 30.4191 0 29.5704V20.6108C0 20.1016 0.202285 19.6133 0.562355 19.2533C0.922425 18.8932 1.41078 18.6909 1.92 18.6909C2.42922 18.6909 2.91758 18.8932 3.27765 19.2533C3.63771 19.6133 3.84 20.1016 3.84 20.6108V28.9304H28.16V20.6108C28.16 20.1016 28.3623 19.6133 28.7224 19.2533C29.0824 18.8932 29.5708 18.6909 30.08 18.6909C30.5892 18.6909 31.0776 18.8932 31.4376 19.2533C31.7977 19.6133 32 20.1016 32 20.6108ZM10.9584 10.4497L14.08 7.33147V20.6108C14.08 21.12 14.2823 21.6084 14.6424 21.9684C15.0024 22.3285 15.4908 22.5307 16 22.5307C16.5092 22.5307 16.9976 22.3285 17.3576 21.9684C17.7177 21.6084 17.92 21.12 17.92 20.6108V7.33147L21.0416 10.4545C21.4023 10.8152 21.8915 11.0178 22.4016 11.0178C22.9117 11.0178 23.4009 10.8152 23.7616 10.4545C24.1223 10.0938 24.3249 9.60466 24.3249 9.09458C24.3249 8.58451 24.1223 8.09533 23.7616 7.73465L17.3616 1.33495C17.1832 1.15596 16.9713 1.01395 16.7379 0.917046C16.5045 0.820145 16.2543 0.770264 16.0016 0.770264C15.7489 0.770264 15.4987 0.820145 15.2653 0.917046C15.0319 1.01395 14.82 1.15596 14.6416 1.33495L8.2416 7.73465C8.063 7.91324 7.92133 8.12525 7.82467 8.35859C7.72802 8.59193 7.67827 8.84202 7.67827 9.09458C7.67827 9.60466 7.88091 10.0938 8.2416 10.4545C8.60229 10.8152 9.0915 11.0178 9.6016 11.0178C10.1117 11.0178 10.6009 10.8152 10.9616 10.4545L10.9584 10.4497Z"
                                fill="white"
                              />
                            </svg>
                            <input
                              onChange={(e) => {
                                setTwoDimensionalMap(e.target.files[0]);
                                setLocalFileUploaded(false);
                              }}
                              className="d-none"
                              type="file"
                              id="map_file_input"
                            />
                          </label>
                          {(twoDimensionalMap || localFileUploaded) && (
                            <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
                              <p>
                                {localFileUploaded ? (
                                  <span>
                                    فایل آپلود شده : {twoDimensionalMap.name}
                                  </span>
                                ) : (
                                  <span>
                                    فایل انتخاب شده : {twoDimensionalMap.name}
                                  </span>
                                )}
                              </p>
                              {!localFileUploaded && (
                                <div className="d-flex align-items-center flex-wrap gap-2">
                                  <button
                                    onClick={() => {
                                      setTwoDimensionalMap(null);
                                      document.getElementById(
                                        "map_file_input"
                                      ).value = null;
                                    }}
                                    className="main-btn bg-danger text-white"
                                  >
                                    حذف
                                  </button>
                                  <button
                                    onClick={twoDimensionalMapHandeler}
                                    className="main-btn main-btn-fill"
                                  >
                                    آپلود
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>

            <div
              className={
                uploadModal || tabInformationRight
                  ? styles.orderInformationLeftContainer
                  : styles.orderInformationLeftContainer2
              }
            >
              <div className={styles.orderInformationLeft}>
                <div
                  className={
                    offlineFileFormat == 0 && Boolean(data.x3d)
                      ? styles.orderPreview
                      : styles.orderPreviewNoPadding
                  }
                >
                  {offlineFileFormat == 0 && Boolean(data.x3d) ? (
                    <>
                      <div
                        className={styles.orderPreviewImg}
                        ref={iFrameContainerRef}
                      >
                        <iframe
                          onLoad={clickForGreenPage}
                          title="x3dFile"
                          srcDoc={`
                                                <html style="overflow: hidden;">
                                                    <head>
                                                        <link rel="stylesheet" href="../../css/x3dom.css">
                                                        <link rel="stylesheet" href="../../css/custom-styles.css">
                                                    </head>

                                                    <body>
                                                        <p style="display: none;" id="itemSelectedShape"></p>
                                                        <p style="display: none;" id="workingFacesPages"></p>
                    
                                                        <div class="cad">
                                                            ${data.x3d}
                                                        </div>

                                                        <button style="display: none;" onclick="selectAllShape()" id="selectAllShape"></button>
                                                        <button style="display: none;" onclick="deselectAll()" id="deselectAll"></button>
                                                        <button style="display: none;" onclick="selectSimilarShape()" id="selectSimilarShape"><button>
                                                        <button style="display: none;" onclick="highlightSimilarShape()" id="highlightSimilarShape"><button>
                                                        <button style="display: none;" onclick="unhighlightSimilarShape()" id="unhighlightSimilarShape"><button>
                                                        <button style="display: none;" onclick="workingFacesItems()" id="workingFacesItems"><button>
                                                        <button style="display: none;" onclick="deselectSelectedShapes()" id="deselectSelectedShapes"><button>
                                                        <button style="display: none;" onclick="setEventToCanvas()" id="setEventToCanvas"><button>
                                                        
                                                        <script src="../../js/custom-js.js"></script>
                                                        <script src="../../js/x3dom-full.js"></script>
                                                    </body>
                                                </html>`}
                        ></iframe>
                      </div>
                      <div className={styles.orderPreviewController}>
                        {/* <button onClick={() => testIconHandler()}>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.939 8.0613C10.7991 7.92194 10.6882 7.75636 10.6125 7.57403C10.5367 7.3917 10.4978 7.19622 10.4978 6.9988C10.4978 6.80138 10.5367 6.6059 10.6125 6.42357C10.6882 6.24124 10.7991 6.07566 10.939 5.9363L14.939 1.9363C15.0783 1.79646 15.2439 1.6855 15.4262 1.6098C15.6086 1.53409 15.804 1.49512 16.0015 1.49512C16.1989 1.49512 16.3944 1.53409 16.5767 1.6098C16.759 1.6855 16.9246 1.79646 17.064 1.9363L21.064 5.9363C21.3457 6.21809 21.5041 6.60029 21.5041 6.9988C21.5041 7.39732 21.3457 7.77951 21.064 8.0613C20.7822 8.34309 20.4 8.5014 20.0015 8.5014C19.6029 8.5014 19.2207 8.34309 18.939 8.0613L17.5002 6.62505V12C17.5002 12.3979 17.3422 12.7794 17.0609 13.0607C16.7796 13.342 16.398 13.5 16.0002 13.5C15.6024 13.5 15.2209 13.342 14.9395 13.0607C14.6582 12.7794 14.5002 12.3979 14.5002 12V6.62505L13.0615 8.0613C12.9221 8.20076 12.7567 8.3114 12.5746 8.38689C12.3925 8.46238 12.1973 8.50123 12.0002 8.50123C11.8031 8.50123 11.6079 8.46238 11.4258 8.38689C11.2437 8.3114 11.0783 8.20076 10.939 8.0613ZM18.939 23.9363L17.5002 25.375V20C17.5002 19.6022 17.3422 19.2207 17.0609 18.9394C16.7796 18.6581 16.398 18.5 16.0002 18.5C15.6024 18.5 15.2209 18.6581 14.9395 18.9394C14.6582 19.2207 14.5002 19.6022 14.5002 20V25.375L13.0615 23.935C12.9219 23.7955 12.7563 23.6848 12.574 23.6093C12.3917 23.5338 12.1963 23.4949 11.999 23.4949C11.8016 23.4949 11.6062 23.5338 11.4239 23.6093C11.2416 23.6848 11.076 23.7955 10.9365 23.935C10.7969 24.0746 10.6862 24.2402 10.6107 24.4225C10.5352 24.6048 10.4964 24.8002 10.4964 24.9975C10.4964 25.1949 10.5352 25.3903 10.6107 25.5726C10.6862 25.7549 10.7969 25.9205 10.9365 26.06L14.9365 30.06C15.0758 30.1999 15.2414 30.3108 15.4237 30.3866C15.6061 30.4623 15.8015 30.5012 15.999 30.5012C16.1964 30.5012 16.3919 30.4623 16.5742 30.3866C16.7565 30.3108 16.9221 30.1999 17.0615 30.06L21.0615 26.06C21.3432 25.7783 21.5016 25.3961 21.5016 24.9975C21.5016 24.599 21.3432 24.2168 21.0615 23.935C20.7797 23.6533 20.3975 23.4949 19.999 23.4949C19.6004 23.4949 19.2182 23.6533 18.9365 23.935L18.939 23.9363ZM30.064 14.9363L26.064 10.9363C25.7822 10.6545 25.4 10.4962 25.0015 10.4962C24.6029 10.4962 24.2207 10.6545 23.939 10.9363C23.6572 11.2181 23.4989 11.6003 23.4989 11.9988C23.4989 12.3973 23.6572 12.7795 23.939 13.0613L25.3752 14.5H20.0002C19.6024 14.5 19.2209 14.6581 18.9395 14.9394C18.6582 15.2207 18.5002 15.6022 18.5002 16C18.5002 16.3979 18.6582 16.7794 18.9395 17.0607C19.2209 17.342 19.6024 17.5 20.0002 17.5H25.3752L23.9352 18.9388C23.6534 19.2206 23.4951 19.6028 23.4951 20.0013C23.4951 20.3998 23.6534 20.782 23.9352 21.0638C24.217 21.3456 24.5992 21.5039 24.9977 21.5039C25.3962 21.5039 25.7784 21.3456 26.0602 21.0638L30.0602 17.0638C30.2001 16.9245 30.3112 16.759 30.387 16.5767C30.4628 16.3944 30.5019 16.199 30.502 16.0016C30.5021 15.8041 30.4633 15.6086 30.3877 15.4263C30.3121 15.2439 30.2012 15.0782 30.0615 14.9388L30.064 14.9363ZM6.62521 17.5H12.0002C12.398 17.5 12.7796 17.342 13.0609 17.0607C13.3422 16.7794 13.5002 16.3979 13.5002 16C13.5002 15.6022 13.3422 15.2207 13.0609 14.9394C12.7796 14.6581 12.398 14.5 12.0002 14.5H6.62521L8.06521 13.0613C8.347 12.7795 8.50531 12.3973 8.50531 11.9988C8.50531 11.6003 8.347 11.2181 8.06521 10.9363C7.78341 10.6545 7.40122 10.4962 7.00271 10.4962C6.60419 10.4962 6.222 10.6545 5.94021 10.9363L1.94021 14.9363C1.80037 15.0757 1.68941 15.2412 1.6137 15.4236C1.53799 15.6059 1.49902 15.8014 1.49902 15.9988C1.49902 16.1962 1.53799 16.3917 1.6137 16.574C1.68941 16.7564 1.80037 16.9219 1.94021 17.0613L5.94021 21.0613C6.07974 21.2008 6.24538 21.3115 6.42769 21.387C6.60999 21.4625 6.80538 21.5014 7.00271 21.5014C7.20003 21.5014 7.39542 21.4625 7.57773 21.387C7.76003 21.3115 7.92568 21.2008 8.06521 21.0613C8.20474 20.9218 8.31542 20.7561 8.39093 20.5738C8.46644 20.3915 8.50531 20.1961 8.50531 19.9988C8.50531 19.8015 8.46644 19.6061 8.39093 19.4238C8.31542 19.2415 8.20474 19.0758 8.06521 18.9363L6.62521 17.5Z" fill="black" />
                                                    </svg>
                                                </button> */}
                        {/* <button>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M27.5 6V12C27.5 12.3978 27.342 12.7794 27.0607 13.0607C26.7794 13.342 26.3978 13.5 26 13.5C25.6022 13.5 25.2206 13.342 24.9393 13.0607C24.658 12.7794 24.5 12.3978 24.5 12V9.625L20.0613 14.065C19.7795 14.3468 19.3973 14.5051 18.9988 14.5051C18.6002 14.5051 18.218 14.3468 17.9363 14.065C17.6545 13.7832 17.4961 13.401 17.4961 13.0025C17.4961 12.604 17.6545 12.2218 17.9363 11.94L22.375 7.5H20C19.6022 7.5 19.2206 7.34196 18.9393 7.06066C18.658 6.77936 18.5 6.39782 18.5 6C18.5 5.60218 18.658 5.22064 18.9393 4.93934C19.2206 4.65804 19.6022 4.5 20 4.5H26C26.3978 4.5 26.7794 4.65804 27.0607 4.93934C27.342 5.22064 27.5 5.60218 27.5 6ZM11.9388 17.9387L7.5 22.375V20C7.5 19.6022 7.34196 19.2206 7.06066 18.9393C6.77936 18.658 6.39782 18.5 6 18.5C5.60218 18.5 5.22064 18.658 4.93934 18.9393C4.65804 19.2206 4.5 19.6022 4.5 20V26C4.5 26.3978 4.65804 26.7794 4.93934 27.0607C5.22064 27.342 5.60218 27.5 6 27.5H12C12.3978 27.5 12.7794 27.342 13.0607 27.0607C13.342 26.7794 13.5 26.3978 13.5 26C13.5 25.6022 13.342 25.2206 13.0607 24.9393C12.7794 24.658 12.3978 24.5 12 24.5H9.625L14.065 20.0613C14.3468 19.7795 14.5051 19.3973 14.5051 18.9988C14.5051 18.6002 14.3468 18.218 14.065 17.9363C13.7832 17.6545 13.401 17.4961 13.0025 17.4961C12.604 17.4961 12.2218 17.6545 11.94 17.9363L11.9388 17.9387ZM26 18.5C25.6022 18.5 25.2206 18.658 24.9393 18.9393C24.658 19.2206 24.5 19.6022 24.5 20V22.375L20.0613 17.935C19.7795 17.6532 19.3973 17.4949 18.9988 17.4949C18.6002 17.4949 18.218 17.6532 17.9363 17.935C17.6545 18.2168 17.4961 18.599 17.4961 18.9975C17.4961 19.396 17.6545 19.7782 17.9363 20.06L22.375 24.5H20C19.6022 24.5 19.2206 24.658 18.9393 24.9393C18.658 25.2206 18.5 25.6022 18.5 26C18.5 26.3978 18.658 26.7794 18.9393 27.0607C19.2206 27.342 19.6022 27.5 20 27.5H26C26.3978 27.5 26.7794 27.342 27.0607 27.0607C27.342 26.7794 27.5 26.3978 27.5 26V20C27.5 19.6022 27.342 19.2206 27.0607 18.9393C26.7794 18.658 26.3978 18.5 26 18.5ZM9.625 7.5H12C12.3978 7.5 12.7794 7.34196 13.0607 7.06066C13.342 6.77936 13.5 6.39782 13.5 6C13.5 5.60218 13.342 5.22064 13.0607 4.93934C12.7794 4.65804 12.3978 4.5 12 4.5H6C5.60218 4.5 5.22064 4.65804 4.93934 4.93934C4.65804 5.22064 4.5 5.60218 4.5 6V12C4.5 12.3978 4.65804 12.7794 4.93934 13.0607C5.22064 13.342 5.60218 13.5 6 13.5C6.39782 13.5 6.77936 13.342 7.06066 13.0607C7.34196 12.7794 7.5 12.3978 7.5 12V9.625L11.9388 14.065C12.2205 14.3468 12.6027 14.5051 13.0013 14.5051C13.3998 14.5051 13.782 14.3468 14.0638 14.065C14.3455 13.7832 14.5039 13.401 14.5039 13.0025C14.5039 12.604 14.3455 12.2218 14.0638 11.94L9.625 7.5Z" fill="black" />
                                                    </svg>
                                                </button> */}
                        {/* <button>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M11 13.5H5C4.60218 13.5 4.22064 13.342 3.93934 13.0607C3.65804 12.7794 3.5 12.3978 3.5 12V6C3.5 5.60218 3.65804 5.22064 3.93934 4.93934C4.22064 4.65804 4.60218 4.5 5 4.5C5.39782 4.5 5.77936 4.65804 6.06066 4.93934C6.34196 5.22064 6.5 5.60218 6.5 6V7.7325C8.58125 5.6825 11.7863 3.5 16 3.5C21.5575 3.5 24.92 6.79875 25.0613 6.93875C25.3394 7.22032 25.4949 7.60039 25.494 7.99614C25.4932 8.3919 25.3359 8.77128 25.0566 9.05162C24.7772 9.33195 24.3984 9.49054 24.0027 9.49281C23.6069 9.49508 23.2263 9.34086 22.9438 9.06375C22.8888 9.01125 20.25 6.5 16 6.5C12.375 6.5 9.6325 8.71 8 10.5H11C11.3978 10.5 11.7794 10.658 12.0607 10.9393C12.342 11.2206 12.5 11.6022 12.5 12C12.5 12.3978 12.342 12.7794 12.0607 13.0607C11.7794 13.342 11.3978 13.5 11 13.5ZM27 18.5H21C20.6022 18.5 20.2206 18.658 19.9393 18.9393C19.658 19.2206 19.5 19.6022 19.5 20C19.5 20.3978 19.658 20.7794 19.9393 21.0607C20.2206 21.342 20.6022 21.5 21 21.5H24C22.375 23.29 19.625 25.5 16 25.5C11.75 25.5 9.11125 22.9887 9.05625 22.935C8.7737 22.6579 8.39309 22.5037 7.99733 22.5059C7.60158 22.5082 7.22276 22.6668 6.94341 22.9471C6.66406 23.2275 6.50682 23.6068 6.50595 24.0026C6.50508 24.3984 6.66064 24.7784 6.93875 25.06C7.08 25.2013 10.4425 28.5 16 28.5C20.2137 28.5 23.4188 26.3175 25.5 24.2675V26C25.5 26.3978 25.658 26.7794 25.9393 27.0607C26.2206 27.342 26.6022 27.5 27 27.5C27.3978 27.5 27.7794 27.342 28.0607 27.0607C28.342 26.7794 28.5 26.3978 28.5 26V20C28.5 19.6022 28.342 19.2206 28.0607 18.9393C27.7794 18.658 27.3978 18.5 27 18.5Z" fill="black" />
                                                    </svg>
                                                </button> */}
                        {/* <button>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M19.4998 14.0001C19.4998 14.3979 19.3418 14.7794 19.0605 15.0607C18.7792 15.342 18.3977 15.5001 17.9998 15.5001H15.4998V18.0001C15.4998 18.3979 15.3418 18.7794 15.0605 19.0607C14.7792 19.342 14.3977 19.5001 13.9998 19.5001C13.602 19.5001 13.2205 19.342 12.9392 19.0607C12.6579 18.7794 12.4998 18.3979 12.4998 18.0001V15.5001H9.99983C9.602 15.5001 9.22047 15.342 8.93917 15.0607C8.65786 14.7794 8.49983 14.3979 8.49983 14.0001C8.49983 13.6022 8.65786 13.2207 8.93917 12.9394C9.22047 12.6581 9.602 12.5001 9.99983 12.5001H12.4998V10.0001C12.4998 9.60225 12.6579 9.22072 12.9392 8.93941C13.2205 8.65811 13.602 8.50007 13.9998 8.50007C14.3977 8.50007 14.7792 8.65811 15.0605 8.93941C15.3418 9.22072 15.4998 9.60225 15.4998 10.0001V12.5001H17.9998C18.3977 12.5001 18.7792 12.6581 19.0605 12.9394C19.3418 13.2207 19.4998 13.6022 19.4998 14.0001ZM29.0611 29.0613C28.9217 29.2012 28.7561 29.3121 28.5738 29.3878C28.3915 29.4635 28.196 29.5025 27.9986 29.5025C27.8012 29.5025 27.6057 29.4635 27.4234 29.3878C27.241 29.3121 27.0754 29.2012 26.9361 29.0613L20.9998 23.1251C18.6804 24.905 15.7708 25.7359 12.8613 25.4494C9.95169 25.163 7.26004 23.7805 5.33231 21.5824C3.40459 19.3843 2.38514 16.5353 2.48078 13.6132C2.57641 10.6911 3.77996 7.91485 5.84728 5.84752C7.9146 3.7802 10.6909 2.57665 13.613 2.48102C16.535 2.38539 19.3841 3.40483 21.5821 5.33256C23.7802 7.26028 25.1627 9.95194 25.4492 12.8615C25.7357 15.7711 24.9047 18.6807 23.1248 21.0001L29.0673 26.9413C29.3474 27.2234 29.5041 27.6051 29.5029 28.0026C29.5017 28.4001 29.3428 28.7809 29.0611 29.0613ZM13.9998 22.5001C15.681 22.5001 17.3244 22.0016 18.7222 21.0676C20.12 20.1336 21.2095 18.8061 21.8528 17.2529C22.4961 15.6997 22.6645 13.9906 22.3365 12.3418C22.0085 10.693 21.199 9.17841 20.0102 7.98967C18.8215 6.80092 17.3069 5.99137 15.6581 5.6634C14.0093 5.33542 12.3002 5.50375 10.747 6.1471C9.19385 6.79044 7.86633 7.87991 6.93234 9.27773C5.99835 10.6755 5.49983 12.3189 5.49983 14.0001C5.50248 16.2536 6.39886 18.4141 7.99234 20.0076C9.58583 21.601 11.7463 22.4974 13.9998 22.5001Z" fill="black" />
                                                    </svg>
                                                </button> */}
                        {/* <button>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M25 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V25C5 25.5304 5.21071 26.0391 5.58579 26.4142C5.96086 26.7893 6.46957 27 7 27H25C25.5304 27 26.0391 26.7893 26.4142 26.4142C26.7893 26.0391 27 25.5304 27 25V7C27 6.46957 26.7893 5.96086 26.4142 5.58579C26.0391 5.21071 25.5304 5 25 5ZM7 7H16V25H7V7Z" fill="black" />
                                                    </svg>
                                                </button> */}
                        {/* <button>
                                                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M29.7686 8.81759L23.1824 2.23259C22.9502 2.00034 22.6746 1.8161 22.3712 1.6904C22.0678 1.5647 21.7426 1.5 21.4143 1.5C21.0859 1.5 20.7607 1.5647 20.4573 1.6904C20.1539 1.8161 19.8783 2.00034 19.6461 2.23259L2.23113 19.6463C1.99887 19.8785 1.81463 20.1541 1.68893 20.4575C1.56323 20.7609 1.49854 21.0861 1.49854 21.4145C1.49854 21.7429 1.56323 22.068 1.68893 22.3714C1.81463 22.6748 1.99887 22.9504 2.23113 23.1826L8.81738 29.7676C9.04954 29.9998 9.32518 30.1841 9.62856 30.3098C9.93194 30.4355 10.2571 30.5002 10.5855 30.5002C10.9139 30.5002 11.2391 30.4355 11.5424 30.3098C11.8458 30.1841 12.1215 29.9998 12.3536 29.7676L29.7686 12.3538C30.0009 12.1217 30.1851 11.846 30.3108 11.5427C30.4365 11.2393 30.5012 10.9141 30.5012 10.5857C30.5012 10.2573 30.4365 9.93215 30.3108 9.62877C30.1851 9.32539 30.0009 9.04975 29.7686 8.81759ZM10.5849 27.2926L4.70988 21.4176L7.99988 18.1251L10.9399 21.0651C11.2217 21.3469 11.6039 21.5052 12.0024 21.5052C12.4009 21.5052 12.7831 21.3469 13.0649 21.0651C13.3467 20.7833 13.505 20.4011 13.505 20.0026C13.505 19.6041 13.3467 19.2219 13.0649 18.9401L10.1249 16.0001L11.9999 14.1251L14.9386 17.0651C15.2204 17.3469 15.6026 17.5052 16.0011 17.5052C16.3996 17.5052 16.7818 17.3469 17.0636 17.0651C17.3454 16.7833 17.5037 16.4011 17.5037 16.0026C17.5037 15.6041 17.3454 15.2219 17.0636 14.9401L14.1249 12.0001L15.9999 10.1251L18.9399 13.0651C19.2217 13.3469 19.6039 13.5052 20.0024 13.5052C20.4009 13.5052 20.7831 13.3469 21.0649 13.0651C21.3467 12.7833 21.505 12.4011 21.505 12.0026C21.505 11.6041 21.3467 11.2219 21.0649 10.9401L18.1249 8.00009L21.4186 4.70759L27.2936 10.5826L10.5849 27.2926Z" fill="black" />
                                                    </svg>
                                                </button> */}
                        {/*<button
                            onClick={() =>
                              setShowHoveredShape((prevValue) => !prevValue)
                            }
                            className={
                              showHoveredShape ? styles.activeButton : ""
                            }
                          >
                            <svg
                              width="32"
                              height="32"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M29.7686 8.81759L23.1824 2.23259C22.9502 2.00034 22.6746 1.8161 22.3712 1.6904C22.0678 1.5647 21.7426 1.5 21.4143 1.5C21.0859 1.5 20.7607 1.5647 20.4573 1.6904C20.1539 1.8161 19.8783 2.00034 19.6461 2.23259L2.23113 19.6463C1.99887 19.8785 1.81463 20.1541 1.68893 20.4575C1.56323 20.7609 1.49854 21.0861 1.49854 21.4145C1.49854 21.7429 1.56323 22.068 1.68893 22.3714C1.81463 22.6748 1.99887 22.9504 2.23113 23.1826L8.81738 29.7676C9.04954 29.9998 9.32518 30.1841 9.62856 30.3098C9.93194 30.4355 10.2571 30.5002 10.5855 30.5002C10.9139 30.5002 11.2391 30.4355 11.5424 30.3098C11.8458 30.1841 12.1215 29.9998 12.3536 29.7676L29.7686 12.3538C30.0009 12.1217 30.1851 11.846 30.3108 11.5427C30.4365 11.2393 30.5012 10.9141 30.5012 10.5857C30.5012 10.2573 30.4365 9.93215 30.3108 9.62877C30.1851 9.32539 30.0009 9.04975 29.7686 8.81759ZM10.5849 27.2926L4.70988 21.4176L7.99988 18.1251L10.9399 21.0651C11.2217 21.3469 11.6039 21.5052 12.0024 21.5052C12.4009 21.5052 12.7831 21.3469 13.0649 21.0651C13.3467 20.7833 13.505 20.4011 13.505 20.0026C13.505 19.6041 13.3467 19.2219 13.0649 18.9401L10.1249 16.0001L11.9999 14.1251L14.9386 17.0651C15.2204 17.3469 15.6026 17.5052 16.0011 17.5052C16.3996 17.5052 16.7818 17.3469 17.0636 17.0651C17.3454 16.7833 17.5037 16.4011 17.5037 16.0026C17.5037 15.6041 17.3454 15.2219 17.0636 14.9401L14.1249 12.0001L15.9999 10.1251L18.9399 13.0651C19.2217 13.3469 19.6039 13.5052 20.0024 13.5052C20.4009 13.5052 20.7831 13.3469 21.0649 13.0651C21.3467 12.7833 21.505 12.4011 21.505 12.0026C21.505 11.6041 21.3467 11.2219 21.0649 10.9401L18.1249 8.00009L21.4186 4.70759L27.2936 10.5826L10.5849 27.2926Z"
                                fill="black"
                              />
                            </svg>
                          </button>
                          */}

                        <button className="controller-btn">
                          <svg
                            version="1.0"
                            xmlns="http://www.w3.org/2000/svg"
                            width="146.000000pt"
                            height="158.000000pt"
                            viewBox="0 0 146.000000 158.000000"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <g
                              transform="translate(0.000000,158.000000) scale(0.100000,-0.100000)"
                              fill="#000000"
                              stroke="none"
                            >
                              <path
                                d="M380 1387 c-247 -136 -320 -180 -337 -207 -23 -33 -23 -36 -23 -388
                                                            0 -333 1 -357 19 -386 15 -24 90 -69 338 -206 267 -147 324 -174 358 -174 32
                                                            1 96 31 320 154 154 84 299 164 323 179 72 45 72 44 72 439 0 345 0 349 -22
                                                            382 -34 50 -636 379 -693 380 -33 0 -94 -30 -355 -173z m643 -147 l188 -103
                                                            -238 -130 -237 -130 -51 27 c-27 14 -135 73 -238 130 l-188 103 238 131 238
                                                            131 50 -28 c28 -15 135 -74 238 -131z m-375 -748 c1 -139 -1 -252 -5 -252 -5
                                                            0 -109 56 -233 124 l-225 124 -3 255 -2 256 232 -128 233 -128 3 -251z m635
                                                            -3 c-5 -4 -109 -62 -233 -129 -124 -67 -228 -124 -232 -127 -5 -2 -8 110 -8
                                                            249 l0 253 238 130 237 130 3 -249 c1 -137 -1 -253 -5 -257z"
                              />
                            </g>
                          </svg>
                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list">
                              {viewPointsArray.map((item) => (
                                <div
                                  key={`viewpoint_${item.value}`}
                                  onClick={() =>
                                    setViewpointHandler(item.value)
                                  }
                                  style={{ position: "relative", zIndex: 999 }}
                                >
                                  {item.text}
                                </div>
                              ))}
                            </div>
                          </div>
                        </button>

                        {/*All Shape button start*/}
                        <button
                          className="controller-btn"
                          id="selectAllShapeButton"
                          name="selectAllShape"
                          /*onClick={() => {
                            const isChecked = !isSelectedAllShapes;
                            selectAllShapeHandler(isChecked);
                            setIsSelectedAllShapes(isChecked);
                          }}*/
                          onClick={() => {
                            if (!isSelectedAllShapes) {
                              selectAllShapesHandler();
                            } else {
                              setIsSelectedAllFeatures(false);
                              setIsSelectedAllShapes(false);
                              setIsSelectedAllFeatures(false);
                              if (
                                [...document.getElementsByTagName("iframe")]
                                  .length === 0
                              ) {
                                return;
                              }
                              document
                                .getElementsByTagName("iframe")[0]
                                .contentWindow.document.getElementById(
                                  "deselectAll"
                                )
                                .click();
                            }
                            handleSetFacesOptions();
                          }}
                        >

                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13 5C13 4.73478 13.1054 4.48043 13.2929 4.29289C13.4804 4.10536 13.7348 4 14 4H18C18.2652 4 18.5196 4.10536 18.7071 4.29289C18.8946 4.48043 19 4.73478 19 5C19 5.26522 18.8946 5.51957 18.7071 5.70711C18.5196 5.89464 18.2652 6 18 6H14C13.7348 6 13.4804 5.89464 13.2929 5.70711C13.1054 5.51957 13 5.26522 13 5ZM18 26H14C13.7348 26 13.4804 26.1054 13.2929 26.2929C13.1054 26.4804 13 26.7348 13 27C13 27.2652 13.1054 27.5196 13.2929 27.7071C13.4804 27.8946 13.7348 28 14 28H18C18.2652 28 18.5196 27.8946 18.7071 27.7071C18.8946 27.5196 19 27.2652 19 27C19 26.7348 18.8946 26.4804 18.7071 26.2929C18.5196 26.1054 18.2652 26 18 26ZM26 4H23C22.7348 4 22.4804 4.10536 22.2929 4.29289C22.1054 4.48043 22 4.73478 22 5C22 5.26522 22.1054 5.51957 22.2929 5.70711C22.4804 5.89464 22.7348 6 23 6H26V9C26 9.26522 26.1054 9.51957 26.2929 9.70711C26.4804 9.89464 26.7348 10 27 10C27.2652 10 27.5196 9.89464 27.7071 9.70711C27.8946 9.51957 28 9.26522 28 9V6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4ZM27 13C26.7348 13 26.4804 13.1054 26.2929 13.2929C26.1054 13.4804 26 13.7348 26 14V18C26 18.2652 26.1054 18.5196 26.2929 18.7071C26.4804 18.8946 26.7348 19 27 19C27.2652 19 27.5196 18.8946 27.7071 18.7071C27.8946 18.5196 28 18.2652 28 18V14C28 13.7348 27.8946 13.4804 27.7071 13.2929C27.5196 13.1054 27.2652 13 27 13ZM27 22C26.7348 22 26.4804 22.1054 26.2929 22.2929C26.1054 22.4804 26 22.7348 26 23V26H23C22.7348 26 22.4804 26.1054 22.2929 26.2929C22.1054 26.4804 22 26.7348 22 27C22 27.2652 22.1054 27.5196 22.2929 27.7071C22.4804 27.8946 22.7348 28 23 28H26C26.5304 28 27.0391 27.7893 27.4142 27.4142C27.7893 27.0391 28 26.5304 28 26V23C28 22.7348 27.8946 22.4804 27.7071 22.2929C27.5196 22.1054 27.2652 22 27 22ZM5 19C5.26522 19 5.51957 18.8946 5.70711 18.7071C5.89464 18.5196 6 18.2652 6 18V14C6 13.7348 5.89464 13.4804 5.70711 13.2929C5.51957 13.1054 5.26522 13 5 13C4.73478 13 4.48043 13.1054 4.29289 13.2929C4.10536 13.4804 4 13.7348 4 14V18C4 18.2652 4.10536 18.5196 4.29289 18.7071C4.48043 18.8946 4.73478 19 5 19ZM9 26H6V23C6 22.7348 5.89464 22.4804 5.70711 22.2929C5.51957 22.1054 5.26522 22 5 22C4.73478 22 4.48043 22.1054 4.29289 22.2929C4.10536 22.4804 4 22.7348 4 23V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H9C9.26522 28 9.51957 27.8946 9.70711 27.7071C9.89464 27.5196 10 27.2652 10 27C10 26.7348 9.89464 26.4804 9.70711 26.2929C9.51957 26.1054 9.26522 26 9 26ZM5 10C5.26522 10 5.51957 9.89464 5.70711 9.70711C5.89464 9.51957 6 9.26522 6 9V6H9C9.26522 6 9.51957 5.89464 9.70711 5.70711C9.89464 5.51957 10 5.26522 10 5C10 4.73478 9.89464 4.48043 9.70711 4.29289C9.51957 4.10536 9.26522 4 9 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V9C4 9.26522 4.10536 9.51957 4.29289 9.70711C4.48043 9.89464 4.73478 10 5 10ZM23 22V10C23 9.73478 22.8946 9.48043 22.7071 9.29289C22.5196 9.10536 22.2652 9 22 9H10C9.73478 9 9.48043 9.10536 9.29289 9.29289C9.10536 9.48043 9 9.73478 9 10V22C9 22.2652 9.10536 22.5196 9.29289 22.7071C9.48043 22.8946 9.73478 23 10 23H22C22.2652 23 22.5196 22.8946 22.7071 22.7071C22.8946 22.5196 23 22.2652 23 22Z"
                              fill="black"
                            />
                          </svg>

                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list relative">
                              <div
                                style={{ position: "relative", zIndex: 999 }}
                              >
                                {selectPointArray[2].text}
                              </div>
                            </div>
                          </div>
                        </button>
                        {/*All shape button END */}

                        {/* select reverse faces */}
                        <button
                          className="controller-btn"
                          id="select3D_1"
                          name="select3D"
                          onClick={() => {
                            if (!isSelectedAllFeatures) {
                              reverseFeaturesHandler();
                              setIsSelectedReverseFeatures(true);
                            } else {
                              setIsSelectedReverseFeatures(false);
                              if (
                                [...document.getElementsByTagName("iframe")]
                                  .length === 0
                              ) {
                                return;
                              }
                              document
                                .getElementsByTagName("iframe")[0]
                                .contentWindow.document.getElementById(
                                  "deselectAll"
                                )
                                .click();
                            }
                            handleSetFacesOptions();
                          }}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M15 23C15 23.2652 14.8946 23.5196 14.7071 23.7071C14.5196 23.8946 14.2652 24 14 24H10C9.73478 24 9.48043 23.8946 9.29289 23.7071C9.10536 23.5196 9 23.2652 9 23C9 22.7348 9.10536 22.4804 9.29289 22.2929C9.48043 22.1054 9.73478 22 10 22H14C14.2652 22 14.5196 22.1054 14.7071 22.2929C14.8946 22.4804 15 22.7348 15 23ZM1 15C1.26522 15 1.51957 14.8946 1.70711 14.7071C1.89464 14.5196 2 14.2652 2 14V10C2 9.73478 1.89464 9.48043 1.70711 9.29289C1.51957 9.10536 1.26522 9 1 9C0.734784 9 0.48043 9.10536 0.292893 9.29289C0.105357 9.48043 5.05013e-08 9.73478 5.05013e-08 10V14C5.05013e-08 14.2652 0.105357 14.5196 0.292893 14.7071C0.48043 14.8946 0.734784 15 1 15ZM5 22H2V19C2 18.7348 1.89464 18.4804 1.70711 18.2929C1.51957 18.1054 1.26522 18 1 18C0.734784 18 0.48043 18.1054 0.292893 18.2929C0.105357 18.4804 5.05013e-08 18.7348 5.05013e-08 19V22C5.05013e-08 22.5304 0.210714 23.0391 0.585786 23.4142C0.960859 23.7893 1.46957 24 2 24H5C5.26522 24 5.51957 23.8946 5.70711 23.7071C5.89464 23.5196 6 23.2652 6 23C6 22.7348 5.89464 22.4804 5.70711 22.2929C5.51957 22.1054 5.26522 22 5 22ZM24 2C24 1.46957 23.7893 0.960859 23.4142 0.585786C23.0391 0.210714 22.5304 5.05013e-08 22 5.05013e-08H2C1.50746 -0.000111026 1.03249 0.183016 0.6675 0.51375C0.610586 0.559004 0.559004 0.610586 0.51375 0.6675C0.183016 1.03249 -0.000111026 1.50746 5.05013e-08 2V5C5.05013e-08 5.26522 0.105357 5.51957 0.292893 5.70711C0.48043 5.89464 0.734784 6 1 6C1.26522 6 1.51957 5.89464 1.70711 5.70711C1.89464 5.51957 2 5.26522 2 5V3.41375L20.5863 22H19C18.7348 22 18.4804 22.1054 18.2929 22.2929C18.1054 22.4804 18 22.7348 18 23C18 23.2652 18.1054 23.5196 18.2929 23.7071C18.4804 23.8946 18.7348 24 19 24H22C22.4923 24 22.9671 23.8174 23.3325 23.4875C23.361 23.4646 23.3882 23.4399 23.4137 23.4137C23.4399 23.3885 23.4641 23.3613 23.4862 23.3325C23.817 22.9675 24.0001 22.4925 24 22V2Z"
                              fill="black"
                            />
                          </svg>

                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list relative">
                              <div
                                style={{ position: "relative", zIndex: 999 }}
                              >
                                {selectPointArray[5].text}
                              </div>
                            </div>
                          </div>
                        </button>
                        {/* end select reverse features */}

                        {/*similar button start*/}
                        <button
                          className="controller-btn"
                          id="select3D_2"
                          name="select3D"
                          onClick={() => {
                            if (!isSelectedSimilarShapes) {
                              similarHandler();
                              setIsSelectedSimilarShapes(true);
                            } else {
                              setIsSelectedSimilarShapes(false);
                              setIsSelectedAllFeatures(false);
                              if (
                                [...document.getElementsByTagName("iframe")]
                                  .length === 0
                              ) {
                                return;
                              }
                              document
                                .getElementsByTagName("iframe")[0]
                                .contentWindow.document.getElementById(
                                  "deselectAll"
                                )
                                .click();
                            }
                            handleSetFacesOptions();
                          }}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M4 9C4 7.67392 4.52678 6.40215 5.46447 5.46447C6.40215 4.52678 7.67392 4 9 4H19C19.6566 4 20.3068 4.12933 20.9134 4.3806C21.52 4.63188 22.0712 5.00017 22.5355 5.46447C22.9998 5.92876 23.3681 6.47995 23.6194 7.08658C23.8707 7.69321 24 8.34339 24 9V19C24 19.6566 23.8707 20.3068 23.6194 20.9134C23.3681 21.52 22.9998 22.0712 22.5355 22.5355C22.0712 22.9998 21.52 23.3681 20.9134 23.6194C20.3068 23.8707 19.6566 24 19 24H9C7.67392 24 6.40215 23.4732 5.46447 22.5355C4.52678 21.5979 4 20.3261 4 19V9ZM14 28C13.2237 28.0006 12.4579 27.8202 11.7635 27.473C11.0691 27.1258 10.4653 26.6214 10 26H19C20.8565 26 22.637 25.2625 23.9497 23.9497C25.2625 22.637 26 20.8565 26 19V8C27.214 8.912 28 10.364 28 12V19C28 21.3869 27.0518 23.6761 25.364 25.364C23.6761 27.0518 21.3869 28 19 28H14Z"
                              fill="black"
                            />
                          </svg>

                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list relative">
                              <div
                                style={{ position: "relative", zIndex: 999 }}
                              >
                                {selectPointArray[1].text}
                              </div>
                            </div>
                          </div>
                        </button>
                        {/*similar button END*/}

                        {/*all feature button start*/}
                        <button
                          className="controller-btn"
                          id="select3D_1"
                          name="select3D"
                          onClick={() => {
                            if (!isSelectedAllFeatures) {
                              allFeaturesHandler();
                              setIsSelectedAllFeatures(true);
                              setIsSelectedSimilarShapes(true);
                            } else {
                              setIsSelectedAllFeatures(false);
                              setIsSelectedSimilarShapes(false);
                              if (
                                [...document.getElementsByTagName("iframe")]
                                  .length === 0
                              ) {
                                return;
                              }
                              document
                                .getElementsByTagName("iframe")[0]
                                .contentWindow.document.getElementById(
                                  "deselectAll"
                                )
                                .click();
                            }
                            handleSetFacesOptions();
                          }}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.3346 10.666H27.3346C27.6883 10.666 28.0274 10.8065 28.2774 11.0565C28.5275 11.3066 28.668 11.6457 28.668 11.9993V27.3327C28.668 27.6863 28.5275 28.0254 28.2774 28.2755C28.0274 28.5255 27.6883 28.666 27.3346 28.666H12.0013C11.6477 28.666 11.3085 28.5255 11.0585 28.2755C10.8084 28.0254 10.668 27.6863 10.668 27.3327V21.3327"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M21.334 4.66634V10.6663L10.6673 21.333H4.66732M21.334 4.66634C21.334 4.31272 21.1935 3.97358 20.9435 3.72353C20.6934 3.47348 20.3543 3.33301 20.0007 3.33301H4.66732C4.3137 3.33301 3.97456 3.47348 3.72451 3.72353C3.47446 3.97358 3.33398 4.31272 3.33398 4.66634V19.9997C3.33398 20.3533 3.47446 20.6924 3.72451 20.9425C3.97456 21.1925 4.3137 21.333 4.66732 21.333M21.334 4.66634L4.66732 21.333M27.334 10.6663L11.334 26.6663M28.6673 15.9997L16.0007 28.6663M16.0007 3.33301L3.33398 15.9997M28.6673 22.6663L22.6673 28.6663M9.33398 3.33301L3.33398 9.33301"
                              stroke="black"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>


                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list relative">
                              <div
                                style={{ position: "relative", zIndex: 999 }}
                              >
                                {selectPointArray[0].text}
                              </div>
                            </div>
                          </div>
                        </button>
                        {/*all feature button END*/}

                        {/* transparency button */}
                        <button
                          className="controller-btn"
                        >
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              opacity="0.2"
                              d="M23 8V23H8L1 16V1H16L23 8Z"
                              fill="black"
                            />
                            <path
                              d="M23.7075 7.2925L16.7075 0.2925C16.6146 0.199666 16.5042 0.126052 16.3829 0.0758637C16.2615 0.0256756 16.1314 -0.000102986 16 3.09201e-07H1C0.734784 3.09201e-07 0.48043 0.105357 0.292893 0.292894C0.105357 0.48043 0 0.734784 0 1V16C0.000110793 16.2624 0.103368 16.5143 0.2875 16.7013L7.2875 23.7013C7.38051 23.7958 7.49141 23.8709 7.61373 23.9222C7.73606 23.9735 7.86736 23.9999 8 24H23C23.2652 24 23.5196 23.8946 23.7071 23.7071C23.8946 23.5196 24 23.2652 24 23V8C24.0001 7.86864 23.9743 7.73855 23.9241 7.61715C23.8739 7.49576 23.8003 7.38544 23.7075 7.2925ZM17 3.41375L20.5863 7H17V3.41375ZM7 20.5863L3.41375 17H7V20.5863ZM7 15H2V3.41375L7 8.41375V15ZM3.41375 2H15V7H8.41375L3.41375 2ZM15 9V15H9V9H15ZM9 22V17H15.5863L20.5863 22H9ZM22 20.5863L17 15.5863V9H22V20.5863Z"
                              fill="black"
                            />
                          </svg>

                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list relative">
                              <div
                                className="flex flex-col items-center"
                                style={{ position: "", zIndex: 999 }}
                              >
                                {selectPointArray[3].text}
                                <input
                                  type="range"
                                  min="0"
                                  max="1"
                                  step="0.1"
                                  value={transparency}
                                  onChange={(ev) =>
                                    setTransparency(ev.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </button>
                        {/* transparency button END */}

                        {/* detail button */}
                        <button
                          className="controller-btn"
                          onClick={() => setShowHoveredShape((prevValue) => !prevValue)}
                          style={{ opacity: showHoveredShape ? "1" : "0.5" }}
                        >

                          <svg
                            width="36"
                            height="36"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M27 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V23C3 23.5304 3.21071 24.0391 3.58579 24.4142C3.96086 24.7893 4.46957 25 5 25L12.4375 25.0075L14.285 28.0287C14.4623 28.3244 14.713 28.5693 15.0127 28.7396C15.3125 28.9098 15.6512 28.9997 15.996 29.0004C16.3408 29.0012 16.6799 28.9128 16.9804 28.7439C17.2809 28.5749 17.5327 28.3312 17.7113 28.0362L19.5662 25H27C27.5304 25 28.0391 24.7893 28.4142 24.4142C28.7893 24.0391 29 23.5304 29 23V7C29 6.46957 28.7893 5.96086 28.4142 5.58579C28.0391 5.21071 27.5304 5 27 5ZM20 18H12C11.7348 18 11.4804 17.8946 11.2929 17.7071C11.1054 17.5196 11 17.2652 11 17C11 16.7348 11.1054 16.4804 11.2929 16.2929C11.4804 16.1054 11.7348 16 12 16H20C20.2652 16 20.5196 16.1054 20.7071 16.2929C20.8946 16.4804 21 16.7348 21 17C21 17.2652 20.8946 17.5196 20.7071 17.7071C20.5196 17.8946 20.2652 18 20 18ZM20 14H12C11.7348 14 11.4804 13.8946 11.2929 13.7071C11.1054 13.5196 11 13.2652 11 13C11 12.7348 11.1054 12.4804 11.2929 12.2929C11.4804 12.1054 11.7348 12 12 12H20C20.2652 12 20.5196 12.1054 20.7071 12.2929C20.8946 12.4804 21 12.7348 21 13C21 13.2652 20.8946 13.5196 20.7071 13.7071C20.5196 13.8946 20.2652 14 20 14Z"
                              fill="black"
                            />

                          </svg>

                          <div className="controller-modal">
                            <div className="controller-modal-content viewpoint-list relative">
                              <div
                                className="flex flex-col items-center"
                                style={{ position: "", zIndex: 999 }}
                              >
                                {selectPointArray[4].text}
                              </div>
                            </div>
                          </div>
                        </button>
                        {/* detail button END */}
                      </div>
                    </>
                  ) : (
                    <img
                      src="/imgs/upload/wisercam image.png"
                      className={styles.offlineImg}
                      alt="Wisercam"
                    />
                  )}
                </div>
                <div className={styles.orderInformationFurther}>
                  <div className={styles.calculatePriceNumber}>
                    <div className={styles.calculateNumber}>
                      <div>
                        <p>{content.numberTitle}</p>
                        <div className={styles.btn}>
                          <button
                            onClick={() => {
                              if (
                                data &&
                                initialized &&
                                !location.pathname.toLowerCase().includes("detailorder") &&
                                !stopSendingRequest
                              ) {
                                setNumber(number + 1);
                              }
                            }}
                          >
                            +
                          </button>
                          <input
                            type="number"
                            onChange={(e) => {
                              if (
                                data &&
                                initialized &&
                                !location.pathname.toLowerCase().includes("detailorder") &&
                                !stopSendingRequest
                              ) {
                                setNumber(
                                  Number.isNaN(
                                    parseInt(numberconvert(e.target.value))
                                  )
                                    ? 1
                                    : parseInt(numberconvert(e.target.value))
                                );
                              }
                            }}
                            value={
                              Number.isNaN(parseInt(number))
                                ? 1
                                : parseInt(number)
                            }
                          />
                          <button
                            onClick={() => {
                              if (
                                data &&
                                initialized &&
                                !location.pathname.toLowerCase().includes("detailorder") &&
                                !stopSendingRequest
                              ) {
                                number > 1 && setNumber(number - 1);
                              }
                            }}
                          >
                            -
                          </button>
                        </div>
                      </div>
                      <div>
                        <p>{content.Timing.title}</p>
                        <div className="input-frame input-frame-two">
                          <select
                            id="CNC"
                            onChange={(e) => {
                              setPlanSelect(e.target.value);
                            }}
                          >
                            <option className="d-none">
                              {planSelect
                                ? propertiesPlan.find(
                                  (item) => item.value == planSelect
                                ).slug
                                : " انتخاب کنید"}
                            </option>
                            {propertiesPlan.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.slug}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className={styles.calculatePrice}>
                      {repricingLoading ? (
                        <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                          <span
                            className="text-primary mt-2"
                            style={{ fontSize: "0.9rem" }}
                          >
                            در حال محاسبه...
                          </span>
                        </div>
                      ) : (
                        <>
                          <p>
                            {content.unitprice.title}&nbsp;
                            {Number.isNaN(Number(unitPrice))
                              ? unitPrice
                              : Number(unitPrice).toLocaleString()}
                            &nbsp;
                            {content.unitprice.unit}
                          </p>
                          <p>
                            {content.totalprice.title}&nbsp;
                            {Number.isNaN(Number(totalPrice))
                              ? totalPrice
                              : Number(totalPrice).toLocaleString()}
                            &nbsp;
                            {content.totalprice.unit}
                          </p>
                          <p>
                            {content.datepreparation.title}&nbsp;
                            {`${datePreparation} روز کاری` || ""}
                          </p>
                        </>
                      )}
                    </div>
                  </div>
                  <span
                    className={styles.infoColor}
                    onClick={() => {
                      setSelectedPlanData(null);
                      setSelectedRowIndex(-1);
                      setPriceModal(true);
                      setTab(Number(planSelect));
                      setStopSendingRequest(true);
                    }}
                  >
                    {content.tariffPrice}
                  </span>
                  <div className={styles.orderInformationBtn}>
                    {!location?.pathname
                      .toLowerCase()
                      .includes("detailorder") && (
                        <button
                          onClick={() =>
                            handleSendData()
                          }
                          className={
                            priceModalItem?.offline == 1 ? styles.warningBtn : ""
                          }
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M28.4582 10.0616L12.9114 26.0616C12.776 26.2015 12.6151 26.3124 12.4379 26.3881C12.2607 26.4638 12.0708 26.5028 11.879 26.5028C11.6871 26.5028 11.4972 26.4638 11.32 26.3881C11.1429 26.3124 10.982 26.2015 10.8466 26.0616L4.04482 19.0616C3.90925 18.9221 3.8017 18.7565 3.72833 18.5741C3.65495 18.3918 3.61719 18.1965 3.61719 17.9991C3.61719 17.8018 3.65495 17.6064 3.72833 17.4241C3.8017 17.2418 3.90925 17.0762 4.04482 16.9366C4.1804 16.7971 4.34136 16.6864 4.5185 16.6109C4.69564 16.5354 4.8855 16.4965 5.07723 16.4965C5.26897 16.4965 5.45883 16.5354 5.63597 16.6109C5.81311 16.6864 5.97406 16.7971 6.10964 16.9366L11.8802 22.8754L26.3958 7.93913C26.6696 7.65733 27.041 7.49902 27.4282 7.49902C27.8155 7.49902 28.1868 7.65733 28.4607 7.93913C28.7345 8.22092 28.8883 8.60311 28.8883 9.00163C28.8883 9.40014 28.7345 9.78233 28.4607 10.0641L28.4582 10.0616Z"
                              fill="white"
                            />
                          </svg>
                          {content.buuton_1}
                        </button>
                      )}
                    <button
                      // onClick={hasErrors || repricingLoading ? () => navigate("/Quotes") : () => handleGoBack()}
                      onClick={() => navigate("/Quotes")}
                      className={
                        priceModalItem?.offline == 1
                          ? styles.warningBtnBack
                          : styles.btnBack
                      }
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.5002 16.0004C28.5002 16.3982 28.3422 16.7797 28.0609 17.061C27.7796 17.3423 27.398 17.5004 27.0002 17.5004H8.62521L15.0652 23.9391C15.347 24.2209 15.5053 24.6031 15.5053 25.0016C15.5053 25.4001 15.347 25.7823 15.0652 26.0641C14.7834 26.3459 14.4012 26.5042 14.0027 26.5042C13.6042 26.5042 13.222 26.3459 12.9402 26.0641L3.94021 17.0641C3.80037 16.9248 3.68941 16.7592 3.6137 16.5769C3.53799 16.3945 3.49902 16.199 3.49902 16.0016C3.49902 15.8042 3.53799 15.6087 3.6137 15.4264C3.68941 15.2441 3.80037 15.0785 3.94021 14.9391L12.9402 5.93913C13.0797 5.7996 13.2454 5.68891 13.4277 5.6134C13.61 5.53789 13.8054 5.49902 14.0027 5.49902C14.2 5.49902 14.3954 5.53789 14.5777 5.6134C14.76 5.68891 14.9257 5.7996 15.0652 5.93913C15.2047 6.07865 15.3154 6.2443 15.3909 6.4266C15.4664 6.60891 15.5053 6.8043 15.5053 7.00163C15.5053 7.19895 15.4664 7.39434 15.3909 7.57665C15.3154 7.75895 15.2047 7.9246 15.0652 8.06413L8.62521 14.5004H27.0002C27.398 14.5004 27.7796 14.6584 28.0609 14.9397C28.3422 15.221 28.5002 15.6026 28.5002 16.0004Z"
                          fill="white"
                        />
                      </svg>
                      {content.button_2}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={priceModal ? "modal-sheet active" : "modal-sheet"}>
            <div className="modal-sheet-content bottomSheet-content">
              <div className="modal-sheet-body">
                <div className={styles.priceModal}>
                  <div className={styles.priceModalHeader}>
                    <div>
                      <h5 className="d-flex align-items-center gap-2 fw-900">
                        <button
                          onClick={() => {
                            setPriceModal(false);
                            setSelectedPlanData(null);
                            setSelectedRowIndex(-1);
                            setStopSendingRequest(false);
                          }}
                        >
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M32.5765 29.9235C32.9287 30.2757 33.1266 30.7534 33.1266 31.2516C33.1266 31.7497 32.9287 32.2275 32.5765 32.5797C32.2243 32.932 31.7465 33.1298 31.2484 33.1298C30.7502 33.1298 30.2725 32.932 29.9202 32.5797L19.9999 22.6563L10.0765 32.5766C9.72425 32.9288 9.24651 33.1267 8.74837 33.1267C8.25023 33.1267 7.77249 32.9288 7.42024 32.5766C7.068 32.2244 6.87012 31.7466 6.87012 31.2485C6.87012 30.7503 7.068 30.2726 7.42024 29.9203L17.3437 20L7.42337 10.0766C7.07113 9.72435 6.87324 9.24661 6.87324 8.74847C6.87324 8.25032 7.07113 7.77258 7.42337 7.42034C7.77561 7.0681 8.25335 6.87021 8.75149 6.87021C9.24964 6.87021 9.72738 7.0681 10.0796 7.42034L19.9999 17.3438L29.9234 7.41878C30.2756 7.06654 30.7534 6.86865 31.2515 6.86865C31.7496 6.86865 32.2274 7.06654 32.5796 7.41878C32.9319 7.77102 33.1297 8.24876 33.1297 8.7469C33.1297 9.24505 32.9319 9.72279 32.5796 10.075L22.6562 20L32.5765 29.9235Z"
                              fill="black"
                            />
                          </svg>
                        </button>
                        {content.priceModal.title}
                      </h5>
                      <p className="mb-1">
                        {/* {content.priceModal.info} */}
                        برای تعداد قطعات بیشتر از{" "}
                        {priceModalItem?.plan_table[tab]?.quantity[
                          priceModalItem?.plan_table[tab]?.quantity?.length - 1
                        ] || 25}{" "}
                        عدد، قیمت‌دهی و تاریخ آماده‌سازی به صورت سفارشی انجام
                        می‌شود تا بتوانیم بهترین پیشنهاد را به شما ارائه کنیم.
                      </p>
                      {/* <a
                                                href="https://wisercam.com/archives/653"
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                راهنمای انتخاب تعداد و زمان‌بندی ساخت قطعات
                                            </a> */}
                    </div>
                    <div>
                      <QuoteImage
                        code={params.id}
                        className="w-100 h-100 object-cover"
                      />
                    </div>
                  </div>
                  <div className={styles.priceModalTab}>
                    <p>{content.priceModal.item[0]}</p>
                    <div>
                      <button
                        className={tab === 0 ? "bg-info color-white" : null}
                        onClick={() => setTabHandler(0)}
                      >
                        {content.priceModal.item[1]}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.2"
                            d="M37.5 17.5V22.5C37.5 23.163 37.2366 23.7989 36.7678 24.2678C36.2989 24.7366 35.663 25 35 25H33.75L30.9219 32.9203C30.8351 33.1633 30.6753 33.3735 30.4644 33.522C30.2535 33.6705 30.0017 33.7502 29.7438 33.75H27.7563C27.4983 33.7502 27.2465 33.6705 27.0356 33.522C26.8247 33.3735 26.6649 33.1633 26.5781 32.9203L25.9828 31.25H15.2672L14.6719 32.9203C14.5851 33.1633 14.4253 33.3735 14.2144 33.522C14.0035 33.6705 13.7517 33.7502 13.4938 33.75H11.5063C11.2483 33.7502 10.9965 33.6705 10.7856 33.522C10.5747 33.3735 10.4149 33.1633 10.3281 32.9203L8.28126 27.1875C6.16773 24.8862 4.99652 21.8745 5.00001 18.75C5.00001 15.4348 6.31697 12.2554 8.66117 9.91117C11.0054 7.56696 14.1848 6.25 17.5 6.25H22.5C24.9392 6.24929 27.3253 6.96226 29.3643 8.30103C31.4033 9.63981 33.006 11.5459 33.975 13.7844C34.1464 14.1817 34.2977 14.5874 34.4281 15H35C35.663 15 36.2989 15.2634 36.7678 15.7322C37.2366 16.2011 37.5 16.837 37.5 17.5Z"
                            fill="black"
                          />
                          <path
                            d="M30 18.125C30 18.4958 29.89 18.8584 29.684 19.1667C29.478 19.475 29.1851 19.7154 28.8425 19.8573C28.4999 19.9992 28.1229 20.0363 27.7592 19.964C27.3955 19.8916 27.0614 19.713 26.7992 19.4508C26.537 19.1886 26.3584 18.8545 26.286 18.4908C26.2137 18.1271 26.2508 17.7501 26.3927 17.4075C26.5346 17.0649 26.775 16.772 27.0833 16.566C27.3916 16.36 27.7542 16.25 28.125 16.25C28.6223 16.25 29.0992 16.4475 29.4508 16.7992C29.8025 17.1508 30 17.6277 30 18.125ZM23.75 10H17.5C17.1685 10 16.8505 10.1317 16.6161 10.3661C16.3817 10.6005 16.25 10.9185 16.25 11.25C16.25 11.5815 16.3817 11.8995 16.6161 12.1339C16.8505 12.3683 17.1685 12.5 17.5 12.5H23.75C24.0815 12.5 24.3995 12.3683 24.6339 12.1339C24.8683 11.8995 25 11.5815 25 11.25C25 10.9185 24.8683 10.6005 24.6339 10.3661C24.3995 10.1317 24.0815 10 23.75 10ZM38.75 17.5V22.5C38.75 23.4946 38.3549 24.4484 37.6516 25.1517C36.9484 25.8549 35.9946 26.25 35 26.25H34.6312L32.0984 33.3406C31.925 33.8263 31.6057 34.2465 31.1841 34.5435C30.7626 34.8406 30.2595 35.0001 29.7437 35H27.7563C27.2405 35.0001 26.7374 34.8406 26.3159 34.5435C25.8943 34.2465 25.575 33.8263 25.4016 33.3406L25.1016 32.5H16.1484L15.8484 33.3406C15.675 33.8263 15.3557 34.2465 14.9341 34.5435C14.5126 34.8406 14.0095 35.0001 13.4937 35H11.5063C10.9905 35.0001 10.4874 34.8406 10.0659 34.5435C9.64433 34.2465 9.32497 33.8263 9.15156 33.3406L7.1875 27.8469C5.31903 25.7322 4.14908 23.0921 3.8375 20.2875C3.4341 20.4994 3.09628 20.8175 2.86055 21.2074C2.62481 21.5974 2.50014 22.0443 2.5 22.5C2.5 22.8315 2.3683 23.1495 2.13388 23.3839C1.89946 23.6183 1.58152 23.75 1.25 23.75C0.918479 23.75 0.600537 23.6183 0.366117 23.3839C0.131696 23.1495 0 22.8315 0 22.5C0.00190997 21.3853 0.376285 20.3031 1.06365 19.4255C1.75101 18.5479 2.71193 17.9252 3.79375 17.6562C4.073 14.2114 5.63753 10.9976 8.17669 8.65301C10.7158 6.30837 14.0439 5.00439 17.5 5H33.75C34.0815 5 34.3995 5.1317 34.6339 5.36612C34.8683 5.60054 35 5.91848 35 6.25C35 6.58152 34.8683 6.89946 34.6339 7.13388C34.3995 7.3683 34.0815 7.5 33.75 7.5H30.4078C32.4823 8.95546 34.1138 10.9563 35.1219 13.2812C35.1891 13.4375 35.2547 13.5938 35.3172 13.75C36.2558 13.8297 37.13 14.2597 37.7661 14.9545C38.4021 15.6493 38.7534 16.558 38.75 17.5ZM36.25 17.5C36.25 17.1685 36.1183 16.8505 35.8839 16.6161C35.6495 16.3817 35.3315 16.25 35 16.25H34.4281C34.1619 16.2503 33.9025 16.1656 33.6878 16.0082C33.4731 15.8508 33.3142 15.629 33.2344 15.375C32.5182 13.0896 31.0904 11.0928 29.1593 9.67617C27.2283 8.25949 24.895 7.49701 22.5 7.5H17.5C15.3167 7.49989 13.1806 8.13505 11.3521 9.32803C9.52364 10.521 8.08178 12.2203 7.20238 14.2186C6.32299 16.2169 6.04405 18.4279 6.39959 20.582C6.75513 22.7362 7.72978 24.7403 9.20469 26.35C9.31747 26.4727 9.4046 26.6166 9.46094 26.7734L11.5063 32.5H13.4937L14.0906 30.8297C14.1773 30.587 14.3368 30.377 14.5475 30.2285C14.7581 30.0799 15.0095 30.0001 15.2672 30H25.9828C26.2405 30.0001 26.4919 30.0799 26.7025 30.2285C26.9132 30.377 27.0727 30.587 27.1594 30.8297L27.7563 32.5H29.7437L32.5734 24.5797C32.6601 24.337 32.8197 24.127 33.0303 23.9785C33.2409 23.8299 33.4923 23.7501 33.75 23.75H35C35.3315 23.75 35.6495 23.6183 35.8839 23.3839C36.1183 23.1495 36.25 22.8315 36.25 22.5V17.5Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                      <button
                        className={tab === 1 ? "bg-info color-white" : null}
                        onClick={() => setTabHandler(1)}
                      >
                        {content.priceModal.item[2]}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.2"
                            d="M28.7708 23.0781C28.5994 23.2286 28.4721 23.4227 28.4022 23.6398C28.3323 23.8568 28.3225 24.0888 28.3739 24.311L30.4864 33.4578C30.5422 33.6967 30.5265 33.9468 30.4412 34.1768C30.3559 34.4069 30.2048 34.6067 30.0068 34.7515C29.8087 34.8962 29.5724 34.9795 29.3273 34.9909C29.0822 35.0023 28.8392 34.9414 28.6286 34.8157L20.6442 29.9719C20.4502 29.8539 20.2275 29.7915 20.0004 29.7915C19.7734 29.7915 19.5507 29.8539 19.3567 29.9719L11.3723 34.8157C11.1616 34.9414 10.9186 35.0023 10.6736 34.9909C10.4285 34.9795 10.1922 34.8962 9.99412 34.7515C9.79605 34.6067 9.64496 34.4069 9.55967 34.1768C9.47438 33.9468 9.45867 33.6967 9.5145 33.4578L11.627 24.311C11.6784 24.0888 11.6686 23.8568 11.5987 23.6398C11.5288 23.4227 11.4014 23.2286 11.2301 23.0781L4.18169 16.9297C3.99325 16.7696 3.85655 16.5571 3.7889 16.3192C3.72124 16.0814 3.72566 15.8288 3.80161 15.5934C3.87755 15.358 4.0216 15.1505 4.21553 14.997C4.40946 14.8436 4.64455 14.7511 4.89106 14.7313L14.1817 13.9281C14.4084 13.908 14.6252 13.8263 14.8089 13.6919C14.9925 13.5575 15.136 13.3756 15.2239 13.1656L18.8536 4.51565C18.9505 4.29201 19.1107 4.1016 19.3145 3.96784C19.5183 3.83408 19.7567 3.76282 20.0004 3.76282C20.2442 3.76282 20.4826 3.83408 20.6864 3.96784C20.8902 4.1016 21.0504 4.29201 21.1473 4.51565L24.777 13.1656C24.8649 13.3756 25.0083 13.5575 25.192 13.6919C25.3757 13.8263 25.5925 13.908 25.8192 13.9281L35.1098 14.7313C35.3563 14.7511 35.5914 14.8436 35.7853 14.997C35.9793 15.1505 36.1233 15.358 36.1993 15.5934C36.2752 15.8288 36.2796 16.0814 36.212 16.3192C36.1443 16.5571 36.0076 16.7696 35.8192 16.9297L28.7708 23.0781Z"
                            fill="black"
                          />
                          <path
                            d="M37.375 15.2016C37.2237 14.735 36.9384 14.3233 36.5547 14.0177C36.171 13.7121 35.7058 13.5261 35.2172 13.4829L25.9375 12.6829L22.3 4.03287C22.1107 3.57899 21.7912 3.19128 21.3819 2.91858C20.9727 2.64588 20.4918 2.50037 20 2.50037C19.5082 2.50037 19.0274 2.64588 18.6181 2.91858C18.2089 3.19128 17.8894 3.57899 17.7 4.03287L14.0735 12.6829L4.78285 13.4876C4.29228 13.5288 3.8248 13.7139 3.43903 14.0198C3.05327 14.3256 2.76639 14.7385 2.61437 15.2068C2.46235 15.675 2.45196 16.1777 2.5845 16.6518C2.71704 17.126 2.98661 17.5504 3.35941 17.8719L10.4078 24.0313L8.29535 33.1782C8.18364 33.6568 8.21552 34.1578 8.38698 34.6185C8.55845 35.0791 8.8619 35.479 9.2594 35.7681C9.6569 36.0572 10.1308 36.2227 10.6219 36.244C11.1129 36.2652 11.5994 36.1413 12.0203 35.8876L19.9891 31.0438L27.975 35.8876C28.396 36.1413 28.8825 36.2652 29.3735 36.244C29.8646 36.2227 30.3385 36.0572 30.736 35.7681C31.1335 35.479 31.4369 35.0791 31.6084 34.6185C31.7799 34.1578 31.8117 33.6568 31.7 33.1782L29.5891 24.0219L36.636 17.8719C37.0087 17.5493 37.2778 17.1237 37.4093 16.6485C37.5408 16.1734 37.5289 15.67 37.375 15.2016ZM34.9969 15.9829L27.95 22.1329C27.6071 22.4312 27.3519 22.8174 27.2121 23.2499C27.0722 23.6824 27.0529 24.1449 27.1563 24.5876L29.2735 33.7501L21.2938 28.9063C20.9045 28.6692 20.4574 28.5438 20.0016 28.5438C19.5458 28.5438 19.0987 28.6692 18.7094 28.9063L10.7407 33.7501L12.8438 24.5938C12.9471 24.1511 12.9279 23.6887 12.788 23.2562C12.6481 22.8236 12.393 22.4375 12.05 22.1391L5.00004 15.9922C4.99946 15.9876 4.99946 15.9829 5.00004 15.9782L14.2875 15.1751C14.741 15.1351 15.1749 14.9721 15.5425 14.7036C15.9101 14.4351 16.1974 14.0714 16.3735 13.6516L20 5.01255L23.625 13.6516C23.8011 14.0714 24.0884 14.4351 24.456 14.7036C24.8236 14.9721 25.2575 15.1351 25.711 15.1751L35 15.9782V15.9891L34.9969 15.9829Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                      <button
                        className={tab === 2 ? "bg-info color-white" : null}
                        onClick={() => setTabHandler(2)}
                      >
                        {content.priceModal.item[3]}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.2"
                            d="M15 37.5L17.5 25L7.5 21.25L25 2.5L22.5 15L32.5 18.75L15 37.5Z"
                            fill="black"
                          />
                          <path
                            d="M33.7168 18.464C33.6694 18.2637 33.5733 18.0781 33.4371 17.9238C33.3008 17.7696 33.1285 17.6513 32.9355 17.5797L23.9339 14.2031L26.2246 2.74528C26.2764 2.47906 26.2403 2.20319 26.1216 1.95931C26.003 1.71543 25.8082 1.51676 25.5667 1.39328C25.3252 1.2698 25.0501 1.22822 24.7829 1.2748C24.5157 1.32139 24.271 1.45361 24.0855 1.65153L6.5855 20.4015C6.44337 20.5513 6.34055 20.7339 6.28622 20.9331C6.2319 21.1323 6.22777 21.3419 6.2742 21.5431C6.32063 21.7443 6.41617 21.9308 6.55229 22.0861C6.68841 22.2413 6.86086 22.3604 7.05425 22.4328L16.0589 25.8093L13.7746 37.2547C13.7227 37.5209 13.7588 37.7967 13.8775 38.0406C13.9962 38.2845 14.1909 38.4832 14.4324 38.6067C14.6739 38.7301 14.949 38.7717 15.2162 38.7251C15.4834 38.6785 15.7282 38.5463 15.9136 38.3484L33.4136 19.5984C33.5532 19.4486 33.6538 19.2668 33.7067 19.069C33.7595 18.8712 33.763 18.6635 33.7168 18.464ZM17.0886 33.4375L18.7246 25.2531C18.7831 24.9628 18.7367 24.6612 18.5936 24.402C18.4506 24.1427 18.2201 23.9427 17.9433 23.8375L9.68706 20.7359L22.9089 6.57028L21.2746 14.7547C21.216 15.0449 21.2624 15.3465 21.4055 15.6058C21.5486 15.865 21.779 16.0651 22.0558 16.1703L30.3058 19.264L17.0886 33.4375Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                      <button
                        className={tab === 3 ? "bg-info color-white" : null}
                        onClick={() => setTabHandler(3)}
                      >
                        {content.priceModal.item[4]}
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.2"
                            d="M37.4663 13.5344L31.6851 31.25C31.6851 31.25 27.5007 28.75 20.0007 28.75C12.5007 28.75 8.31634 31.25 8.31634 31.25L2.53509 13.5359C2.49349 13.4155 2.48876 13.2853 2.52153 13.1621C2.55429 13.039 2.62305 12.9284 2.71901 12.8445C2.81497 12.7606 2.93377 12.7072 3.06022 12.6913C3.18667 12.6753 3.31502 12.6973 3.42884 12.7547L11.7742 16.9141C11.9188 16.9863 12.0854 17.0014 12.2406 16.9562C12.3959 16.911 12.5284 16.8089 12.6117 16.6703L19.4507 5.3125C19.5082 5.21911 19.5886 5.14201 19.6844 5.08852C19.7801 5.03504 19.8879 5.00696 19.9976 5.00696C20.1073 5.00696 20.2151 5.03504 20.3108 5.08852C20.4065 5.14201 20.487 5.21911 20.5445 5.3125L27.3835 16.6781C27.467 16.8161 27.5992 16.9176 27.754 16.9628C27.9088 17.0079 28.0749 16.9933 28.2195 16.9219L36.5679 12.7594C36.6813 12.7015 36.8094 12.6787 36.9358 12.6939C37.0622 12.7091 37.1812 12.7617 37.2777 12.8448C37.3741 12.928 37.4435 13.038 37.4771 13.1608C37.5107 13.2837 37.507 13.4137 37.4663 13.5344Z"
                            fill="black"
                          />
                          <path
                            d="M38.1002 11.9046C37.8182 11.6588 37.4696 11.5023 37.0984 11.455C36.7273 11.4077 36.3505 11.4717 36.0159 11.639L28.1705 15.5453L21.6205 4.66558C21.4522 4.3864 21.2145 4.15546 20.9306 3.99515C20.6468 3.83485 20.3263 3.75061 20.0002 3.75061C19.6742 3.75061 19.3537 3.83485 19.0698 3.99515C18.786 4.15546 18.5483 4.3864 18.3799 4.66558L11.8299 15.55L3.98774 11.6437C3.6539 11.4779 3.27852 11.4144 2.90872 11.4612C2.53892 11.5079 2.19117 11.6629 1.9091 11.9065C1.62704 12.1502 1.42323 12.4718 1.32324 12.8309C1.22326 13.1899 1.23157 13.5706 1.34711 13.925L7.12836 31.6375C7.18649 31.8154 7.28384 31.978 7.41323 32.1133C7.54262 32.2486 7.70074 32.3531 7.87591 32.4191C8.05109 32.4851 8.23886 32.5109 8.42534 32.4946C8.61183 32.4783 8.79228 32.4203 8.95336 32.325C8.99242 32.3015 12.9877 30 20.0002 30C27.0127 30 31.008 32.3015 31.044 32.3234C31.2051 32.4197 31.3859 32.4784 31.5728 32.4953C31.7598 32.5121 31.9482 32.4867 32.1239 32.4208C32.2997 32.3549 32.4584 32.2503 32.5882 32.1147C32.718 31.979 32.8155 31.8159 32.8737 31.6375L38.6549 13.9296C38.7738 13.5752 38.7845 13.1933 38.6857 12.8327C38.587 12.4721 38.3832 12.1491 38.1002 11.9046ZM30.9377 29.5046C29.0627 28.7093 25.3252 27.5 20.0002 27.5C14.6752 27.5 10.9377 28.7093 9.06274 29.5046L4.17368 14.5312L11.2159 18.0421C11.6421 18.2523 12.1317 18.2953 12.588 18.1626C13.0444 18.0298 13.4345 17.731 13.6815 17.325L20.0002 6.82183L26.319 17.3218C26.566 17.7275 26.9558 18.026 27.4118 18.1588C27.8678 18.2915 28.357 18.2488 28.7831 18.039L35.8268 14.5312L30.9377 29.5046Z"
                            fill="black"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  {priceModalItem && priceModalItem.plan_table.length > 0 ? (
                    <div className={styles.priceModalTable}>
                      {tab === 0 ? (
                        <table className="w-100">
                          <thead>
                            <tr>
                              {json.OrderInformation.priceModal.tabelHeader_1.map(
                                (item, index) => (
                                  <th key={index}>{item}</th>
                                )
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {priceModalItem.plan_table[0].time.map(
                              (item, index) => (
                                <tr
                                  key={`${tab}_${index}_row`}
                                  onClick={() => setSelectedPriceHandler(index)}
                                  className={
                                    selectedRowIndex === index
                                      ? styles.activePlanTableRow
                                      : ""
                                  }
                                >
                                  <td>
                                    {priceModalItem.plan_table[0].time[index]}{" "}
                                    روز کاری
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[0].total_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[0].unit_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {
                                      priceModalItem.plan_table[0].quantity[
                                      index
                                      ]
                                    }
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan="4">
                                حالت فعلی
                                <span className="mx-1">
                                  (
                                  {
                                    propertiesPlan.find(
                                      (item) => item.value == planSelect
                                    )?.slug
                                  }
                                  )
                                </span>
                              </th>
                            </tr>
                            <tr>
                              <td>{priceModalItem.time} روز کاری</td>
                              <td>
                                {priceModalItem.total_price.toLocaleString()}
                              </td>
                              <td>
                                {priceModalItem.unit_price.toLocaleString()}
                              </td>
                              <td>
                                {Number.isNaN(Number(number))
                                  ? 1
                                  : Number(number)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      ) : null}
                      {tab === 1 ? (
                        <table className="w-100">
                          <thead>
                            <tr>
                              {json.OrderInformation.priceModal.tabelHeader_1.map(
                                (item, index) => (
                                  <th key={index}>{item}</th>
                                )
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {priceModalItem.plan_table[1].time.map(
                              (item, index) => (
                                <tr
                                  key={`${tab}_${index}_row`}
                                  onClick={() => setSelectedPriceHandler(index)}
                                  className={
                                    selectedRowIndex === index
                                      ? styles.activePlanTableRow
                                      : ""
                                  }
                                >
                                  <td>
                                    {priceModalItem.plan_table[1].time[index]}{" "}
                                    روز کاری
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[1].total_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[1].unit_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {
                                      priceModalItem.plan_table[1].quantity[
                                      index
                                      ]
                                    }
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan="4">
                                حالت فعلی
                                <span className="mx-1">
                                  (
                                  {
                                    propertiesPlan.find(
                                      (item) => item.value == planSelect
                                    )?.slug
                                  }
                                  )
                                </span>
                              </th>
                            </tr>
                            <tr
                            // onClick={() => setSelectedDefaultPriceHandler()}
                            // className={
                            //   selectedRowIndex === -1
                            //     ? styles.activePlanTableRow
                            //     : ""
                            // }
                            >
                              <td>{priceModalItem.time} روز کاری</td>
                              <td>
                                {priceModalItem.total_price.toLocaleString()}
                              </td>
                              <td>
                                {priceModalItem.unit_price.toLocaleString()}
                              </td>
                              <td>
                                {Number.isNaN(Number(number))
                                  ? 1
                                  : Number(number)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      ) : null}
                      {tab === 2 ? (
                        <table className="w-100">
                          <thead>
                            <tr>
                              {json.OrderInformation.priceModal.tabelHeader_1.map(
                                (item, index) => (
                                  <th key={index}>{item}</th>
                                )
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {priceModalItem.plan_table[2].time.map(
                              (item, index) => (
                                <tr
                                  key={`${tab}_${index}_row`}
                                  onClick={() => setSelectedPriceHandler(index)}
                                  className={
                                    selectedRowIndex === index
                                      ? styles.activePlanTableRow
                                      : ""
                                  }
                                >
                                  <td>
                                    {priceModalItem.plan_table[2].time[index]}{" "}
                                    روز کاری
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[2].total_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[2].unit_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {
                                      priceModalItem.plan_table[2].quantity[
                                      index
                                      ]
                                    }
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan="4">
                                حالت فعلی
                                <span className="mx-1">
                                  (
                                  {
                                    propertiesPlan.find(
                                      (item) => item.value == planSelect
                                    )?.slug
                                  }
                                  )
                                </span>
                              </th>
                            </tr>
                            <tr
                            // onClick={() => setSelectedDefaultPriceHandler()}
                            // className={
                            //   selectedRowIndex === -1
                            //     ? styles.activePlanTableRow
                            //     : ""
                            // }
                            >
                              <td>{priceModalItem.time} روز کاری</td>
                              <td>
                                {priceModalItem.total_price.toLocaleString()}
                              </td>
                              <td>
                                {priceModalItem.unit_price.toLocaleString()}
                              </td>
                              <td>
                                {Number.isNaN(Number(number))
                                  ? 1
                                  : Number(number)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      ) : null}
                      {tab === 3 ? (
                        <table className="w-100">
                          <thead>
                            <tr>
                              {json.OrderInformation.priceModal.tabelHeader_1.map(
                                (item, index) => (
                                  <th key={index}>{item}</th>
                                )
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {priceModalItem.plan_table[3].time.map(
                              (item, index) => (
                                <tr
                                  key={`${tab}_${index}_row`}
                                  onClick={() => setSelectedPriceHandler(index)}
                                  className={
                                    selectedRowIndex === index
                                      ? styles.activePlanTableRow
                                      : ""
                                  }
                                >
                                  <td>
                                    {priceModalItem.plan_table[3].time[index]}{" "}
                                    روز کاری
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[3].total_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {priceModalItem.plan_table[3].unit_price[
                                      index
                                    ].toLocaleString()}
                                  </td>
                                  <td>
                                    {
                                      priceModalItem.plan_table[3].quantity[
                                      index
                                      ]
                                    }
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                              <th colSpan="4">
                                حالت فعلی
                                <span className="mx-1">
                                  (
                                  {
                                    propertiesPlan.find(
                                      (item) => item.value == planSelect
                                    )?.slug
                                  }
                                  )
                                </span>
                              </th>
                            </tr>
                            <tr
                            // onClick={() => setSelectedDefaultPriceHandler()}
                            // className={
                            //   selectedRowIndex === -1
                            //     ? styles.activePlanTableRow
                            //     : ""
                            // }
                            >
                              <td>{priceModalItem.time} روز کاری</td>
                              <td>
                                {priceModalItem.total_price.toLocaleString()}
                              </td>
                              <td>
                                {priceModalItem.unit_price.toLocaleString()}
                              </td>
                              <td>
                                {Number.isNaN(Number(number))
                                  ? 1
                                  : Number(number)}
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      ) : null}
                    </div>
                  ) : null}
                  <div className={styles.orderInformationBtn}>
                    <button onClick={setRepriceData}>
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.4582 10.0616L12.9114 26.0616C12.776 26.2015 12.6151 26.3124 12.4379 26.3881C12.2607 26.4638 12.0708 26.5028 11.879 26.5028C11.6871 26.5028 11.4972 26.4638 11.32 26.3881C11.1429 26.3124 10.982 26.2015 10.8466 26.0616L4.04482 19.0616C3.90925 18.9221 3.8017 18.7565 3.72833 18.5741C3.65495 18.3918 3.61719 18.1965 3.61719 17.9991C3.61719 17.8018 3.65495 17.6064 3.72833 17.4241C3.8017 17.2418 3.90925 17.0762 4.04482 16.9366C4.1804 16.7971 4.34136 16.6864 4.5185 16.6109C4.69564 16.5354 4.8855 16.4965 5.07723 16.4965C5.26897 16.4965 5.45883 16.5354 5.63597 16.6109C5.81311 16.6864 5.97406 16.7971 6.10964 16.9366L11.8802 22.8754L26.3958 7.93913C26.6696 7.65733 27.041 7.49902 27.4282 7.49902C27.8155 7.49902 28.1868 7.65733 28.4607 7.93913C28.7345 8.22092 28.8883 8.60311 28.8883 9.00163C28.8883 9.40014 28.7345 9.78233 28.4607 10.0641L28.4582 10.0616Z"
                          fill="white"
                        />
                      </svg>
                      {content.priceModal.button_1}
                    </button>
                    <button
                      onClick={() => {
                        setPriceModal(false);
                        setSelectedPlanData(null);
                        setSelectedRowIndex(-1);
                        setStopSendingRequest(false);
                      }}
                    >
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M28.5002 16.0004C28.5002 16.3982 28.3422 16.7797 28.0609 17.061C27.7796 17.3423 27.398 17.5004 27.0002 17.5004H8.62521L15.0652 23.9391C15.347 24.2209 15.5053 24.6031 15.5053 25.0016C15.5053 25.4001 15.347 25.7823 15.0652 26.0641C14.7834 26.3459 14.4012 26.5042 14.0027 26.5042C13.6042 26.5042 13.222 26.3459 12.9402 26.0641L3.94021 17.0641C3.80037 16.9248 3.68941 16.7592 3.6137 16.5769C3.53799 16.3945 3.49902 16.199 3.49902 16.0016C3.49902 15.8042 3.53799 15.6087 3.6137 15.4264C3.68941 15.2441 3.80037 15.0785 3.94021 14.9391L12.9402 5.93913C13.0797 5.7996 13.2454 5.68891 13.4277 5.6134C13.61 5.53789 13.8054 5.49902 14.0027 5.49902C14.2 5.49902 14.3954 5.53789 14.5777 5.6134C14.76 5.68891 14.9257 5.7996 15.0652 5.93913C15.2047 6.07865 15.3154 6.2443 15.3909 6.4266C15.4664 6.60891 15.5053 6.8043 15.5053 7.00163C15.5053 7.19895 15.4664 7.39434 15.3909 7.57665C15.3154 7.75895 15.2047 7.9246 15.0652 8.06413L8.62521 14.5004H27.0002C27.398 14.5004 27.7796 14.6584 28.0609 14.9397C28.3422 15.221 28.5002 15.6026 28.5002 16.0004Z"
                          fill="white"
                        />
                      </svg>
                      {content.priceModal.button_2}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal-sheet-back"
              onClick={() => {
                setPriceModal(false);
                setStopSendingRequest(false);
              }}
            ></div>
          </div>
        </div>
      ) : (
        <Notfound />
      )}
    </MainLayout>
  );
};

export default EditOrder;
